<template>
  <div>
    <ContainerTruckSale
      ref="ContainerTruckSale"
      :value.sync="request_quotation"
      v-if="
        step == 'booking' &&
        request_quotation &&
        request_quotation.service_type &&
        request_quotation.service_type.toString() == '5'
      "
    />
    <NewVanTruckSale
      ref="NewVanTruckSale"
      :value.sync="request_quotation"
      v-else-if="
        step == 'booking' &&
        request_quotation &&
        request_quotation.service_type &&
        request_quotation.service_type.toString() == '6'
      "
    />
    <NewBookingSale
      ref="NewBookingSale"
      :valueCopy.sync="request_quotation"
      v-else-if="
        step == 'booking' &&
        request_quotation && isCopy == true &&
        request_quotation.service_type &&
        request_quotation.service_type.toString() == '3'
      "
    />

    <div v-else :class="className" style="padding-bottom: 50px">
      <b-row
        v-if="
          (!readonly && step == 'booking') ||
          (step == 'created-quotation' && step != 'view-created-quotation')
        "
      >
        <b-col cols="12">
          <h4 class="text-success font-weight-bold">
            {{ $t("titleCreatedQuotation") }}
          </h4>
        </b-col>
        <b-col cols="12"
          ><small>{{ $t("textCreatedQuotation") }}</small></b-col
        >
      </b-row>
      <b-row v-if="request_quotation.status_id == 10">
        <b-col cols="12">
          <b-form-group>
            <label>Cancellation reasons</label>
            <b-form-textarea
              :disabled="readonly"
              v-model="request_quotation.cancel_reason"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <validation-observer name="Customer" ref="bcRules">
        <b-row
          v-if="
            !isCustomer &&
            (step == 'booking' ||
              (step == 'created-quotation' && step != 'view-created-quotation'))
          "
        >
          <b-col cols="12" class="pt-1">
            <validation-provider
              name="Company"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <Select4
                  v-model="request_quotation.company_id"
                  :disabled="readonly"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Select Company"
                  @select="
                    () => {
                      request_quotation.customer_id = '';
                      onSelectService();
                    }
                  "
                  :options="{
                    isSearch: true,
                    value: 'code',
                    label: 'text',
                    data: company_list,
                    fields: [
                      {
                        field: 'code',
                        label: 'Tax Code',
                      },

                      { field: 'name', label: 'Name' },
                      {
                        field: 'acronym',
                        label: 'Acronym',
                      },
                    ],
                  }"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" class="pt-1">
            <validation-provider
              name="Customer"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  @select="onSelectService()"
                  :disabled="readonly || !request_quotation.company_id"
                  placeholder="Select Customer"
                  v-model="request_quotation.customer_id"
                  :options="customer_list_options"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="pt-1">
          <b-col cols="12">
            <validation-provider
              name="Service Type"
              #default="{ errors }"
              rules="required"
              v-if="!readonly"
            >
              <b-form-group>
                <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  :disabled="readonly || readonlyService"
                  placeholder="Select Service Type"
                  @select="onSelectService()"
                  v-model="request_quotation.service_type"
                  :options="service_types"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </validation-observer>
      <validation-observer
        v-if="
          request_quotation.service_type != null ||
          view_RequestQuotation != null
        "
        ref="requestQuotationRules"
      >
        <!--FCL-->
        <div v-if="request_quotation.service_type && request_quotation.service_type.toString() == '2'">
          <b-row>
            <b-col cols="12" class="pt-1">
              <h4>Freight Informations</h4>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="POL"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>POL<font class="red">*</font></label>
                  <div class="d-flex">
                    <!-- <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="AOL/POL"
                      select="code"
                      name="code"
                      class="w-100"
                      id="code"
                      v-model="request_quotation.pol_port"
                      :options="ports"
                    /> -->
                    <Select4
                      v-model="request_quotation.pol_port"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="AOL/POL"
                      :disabled="readonly"
                      :options="{
                        value: 'code',
                        label: 'name',
                        data: ports,
                        fields: [
                          {
                            field: 'code',
                            label: 'Code',
                          },
                          {
                            field: 'name',
                            label: 'Name',
                          },
                          {
                            field: 'country_code',
                            label: 'Country Code',
                          },
                        ],
                      }"
                    />
                    <!-- <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" :disabled="readonly"
                      @click.once="getDataPolPod" v-b-tooltip.hover v-if="!isCustomer"
                      title="Data synchronization with FAST" :key="buttonKey" class="btn-icon ml-1">
                      <feather-icon icon="RefreshCwIcon" />
                    </b-button> -->
                  </div>

                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="POD"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>POD<font class="red">*</font></label>
                  <!-- <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="AOD/POD"
                    v-model="request_quotation.pod_port"
                    :options="ports"
                  /> -->
                  <Select4
                    v-model="request_quotation.pod_port"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="AOD/POD"
                    :disabled="readonly"
                    :options="{
                      value: 'code',
                      label: 'name',
                      data: ports,
                      fields: [
                        {
                          field: 'code',
                          label: 'Code',
                        },
                        {
                          field: 'name',
                          label: 'Name',
                        },
                        {
                          field: 'country_code',
                          label: 'Country Code',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" :lg="4">
              <validation-provider
                name="From"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Cargo ready<font class="red">*</font></label>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.cargo_ready"
                    type="datetime"
                    class="w-full"
                    value-type="format"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              :lg="
                step == 'booking' || step == 'view-quotation-booking' ? 6 : 4
              "
            >
              <validation-provider
                name="Payment Terms"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Payment Terms</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Payment Terms"
                    v-model="request_quotation.paymentTerms"
                    :options="$Options.paymentTerms"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!--  Carrier -->

            <b-col
              cols="12"
              :lg="
                step == 'booking' || step == 'view-quotation-booking' ? 6 : 4
              "
            >
              <validation-provider
                name="Carrier"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Carrier</label>
                  <Select4
                    v-model="request_quotation.shipping_line"
                    :class="[
                      errors.length > 0 ? 'is-invalid' : null,
                      readonly == true ? 'remove' : '',
                    ]"
                    placeholder="Carrier"
                    :disabled="readonly"
                    :options="{
                      value: 'id',
                      label: 'text',
                      data: shipping_lines,
                      fields: [
                        {
                          field: 'code',
                          label: 'Code',
                        },
                        {
                          field: 'name',
                          label: 'Shipping Line',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              lg="4"
              v-if="step != 'view-quotation-booking' && step != 'booking'"
            >
              <b-form-group>
                <label>Volume (Monthly)</label>
                <!-- <Select2
                  :disabled="readonly"
                  placeholder="Volume (Monthly)"
                  v-model="request_quotation.volume"
                  :options="volumes"
                /> -->
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.volume"
                  placeholder="Volume (Monthly)"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="step == 'booking' || step == 'view-quotation-booking'">
            <b-col cols="6">
              <validation-provider name="ETD" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETD </label>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.etd"
                    type="date"
                    :title="request_quotation.etd"
                    class="w-full"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    value-type="format"
                    title-format="DD/MM/YY"
                    :disabled="readonly"
                    time-title-format="DD/MM/YY"
                    placeholder="Select date"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY"
                    @close="handleOpenChange"
                  >
                  </date-picker>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider name="ETA" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETA </label>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.eta"
                    type="date"
                    :title="request_quotation.eta"
                    class="w-full"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    value-type="format"
                    title-format="DD/MM/YY"
                    :disabled="readonly"
                    time-title-format="DD/MM/YY"
                    placeholder="Select date"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY"
                    @close="handleOpenChange"
                  >
                  </date-picker>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" class="pt-1">
              <h4>Cargo Information</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Commodity"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Commodity<font class="red">*</font></label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Commodity"
                    v-model="request_quotation.goods_type"
                    :options="goods_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Commodity description"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Commodity description</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.mo_ta"
                    placeholder="Commodity description"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Gross Weight (kgs)"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Total Gross Weight (kg)</label>
                  <cleave
                    :state="errors.length > 0 ? false : null"
                    :options="$Utils.CONSTANTS.cleaveNumeral"
                    :disabled="readonly"
                    v-model="request_quotation.trong_luong"
                    class="form-control"
                    placeholder="Gross Weight (kgs)"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- -->
          </b-row>

          <b-row>
            <b-col cols="12" class="pt-1">
              <h4>Shipment Informations</h4>
            </b-col>
          </b-row>
          <b-row v-if="step == 'booking'">
            <b-col cols="12" md="6">
              <validation-provider
                name="BK/HBL/INV"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>BK/HBL/INV </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.bk_hbl_inv"
                    placeholder="BK/HBL/INV"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Shipping Type</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Shipping Type"
                  v-model="request_quotation.shippingType"
                  :options="
                    request_quotation.service_type == 5
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : request_quotation.service_type == 6
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : transport_types.filter((i) => [1, 2].includes(i.id))
                  "
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Container Type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Container Type</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Container Type"
                    v-model="request_quotation.cont_type"
                    :options="
                      cont_types.filter((i) => i.group === 'Container truck')
                    "
                  />
                  <!-- <b-form-input
                    type="number"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.cont_type"
                    placeholder="Container Type"
                  /> -->
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Quantity"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Quantity</label>
                  <b-form-input
                    type="number"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.so_luong"
                    placeholder="Quantity"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row v-if="step == 'booking'">
            <b-col cols="12" lg="6">
              <validation-provider
                name="Container No."
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Container No.</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.container_no"
                    placeholder="Quantity"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Seal No."
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Seal No.</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.seal"
                    placeholder="Quantity"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <section v-if="request_quotation.has_container_trucking">
            <b-row
              v-if="
                step == 'created-quotation' ||
                step == 'view-created-quotation' ||
                (step == 'view-quotation-booking' &&
                  (request_quotation.pickup_region != null ||
                    request_quotation.other_pickup_region) &&
                  step != 'booking')
              "
            >
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Pick up"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Pick up<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select2
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="hide_select"
                        :disabled="readonly"
                        v-if="!request_quotation.isHideShows"
                        placeholder="Pick up"
                        v-model="request_quotation.pickup_region"
                        :options="regions"
                      />
                      <b-form-input
                        :disabled="readonly"
                        v-if="request_quotation.isHideShows"
                        v-model="request_quotation.other_pickup_region"
                        placeholder="Enter pick up "
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsi"
                        v-model="request_quotation.isHideShows"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Delivery"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Delivery<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select2
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="hide_select"
                        v-if="!request_quotation.isHideShowPk"
                        :disabled="readonly"
                        placeholder="Delivery"
                        v-model="request_quotation.delivery_region"
                        :options="regions"
                      />
                      <b-form-input
                        :disabled="readonly"
                        v-if="request_quotation.isHideShowPk"
                        v-model="request_quotation.other_delivery_region"
                        placeholder="Enter pick up"
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsPk"
                        v-model="request_quotation.isHideShowPk"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group>
                  <label>Empty depot</label>
                  <Select2
                    :disabled="readonly"
                    placeholder="Empty depot"
                    v-model="request_quotation.deport"
                    :options="regions"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-else>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Pick up"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Pick up<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select4
                        v-model="request_quotation.pickup_location"
                        :key="countRq"
                        :class="
                          errors.length > 0
                            ? 'is-invalid hide_select'
                            : 'hide_select'
                        "
                        placeholder="Enter Pick up "
                        v-if="!request_quotation.isHideShows"
                        :disabled="readonly"
                        :options="{
                          value: 'id',
                          label: 'text',
                          data: locations,
                          fields: [
                            {
                              field: 'abbreviations',
                              label: 'Abbreviations',
                            },
                            {
                              field: 'name',
                              label: 'Location',
                            },
                            {
                              field: 'address',
                              label: 'Address',
                            },
                          ],
                        }"
                      />
                      <b-form-input
                        :disabled="readonly"
                        v-if="request_quotation.isHideShows"
                        v-model="request_quotation.other_pickup_location"
                        placeholder="Enter pick up "
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsi"
                        v-model="request_quotation.isHideShows"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Delivery"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Delivery<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select4
                        v-model="request_quotation.delivery_location"
                        :key="countRq"
                        :class="
                          errors.length > 0
                            ? 'is-invalid hide_select'
                            : 'hide_select'
                        "
                        placeholder="Enter Delivery "
                        v-if="!request_quotation.isHideShowPk"
                        :disabled="readonly"
                        :options="{
                          value: 'id',
                          label: 'text',
                          data: locations,
                          fields: [
                            {
                              field: 'abbreviations',
                              label: 'Abbreviations',
                            },
                            {
                              field: 'name',
                              label: 'Location',
                            },
                            {
                              field: 'address',
                              label: 'Address',
                            },
                          ],
                        }"
                      />
                      <b-form-input
                        :disabled="readonly"
                        v-if="request_quotation.isHideShowPk"
                        v-model="request_quotation.other_delivery_location"
                        placeholder="Enter pick up"
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsPk"
                        v-model="request_quotation.isHideShowPk"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col
                cols="12"
                lg="4"
                v-if="
                  step != 'created-quotation' &&
                  step != 'view-created-quotation'
                "
              >
                <b-form-group>
                  <label>Empty depot </label>

                  <Select4
                    v-model="request_quotation.deport_location"
                    :key="countRq"
                    placeholder="Empty depot"
                    :disabled="readonly"
                    :options="{
                      value: 'id',
                      label: 'text',
                      data: locations,
                      fields: [
                        {
                          field: 'abbreviations',
                          label: 'Abbreviations',
                        },
                        {
                          field: 'name',
                          label: 'Location',
                        },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </section>

          <b-row> </b-row>
          <!-- TO DO -->

          <b-row
            v-if="
              request_quotation.has_container_trucking &&
              (step == 'booking' || step == 'view-quotation-booking')
            "
          >
            <b-col cols="12" lg="4">
              <b-form-group>
                <label>Pick up date</label>

                <section>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.pick_up_date"
                    type="datetime"
                    class="w-full"
                    :disabled="readonly"
                    value-type="format"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>
                </section>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
              <b-form-group>
                <label>Delivery Date</label>

                <section>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.delivery_date"
                    :disabled-date="disabledRangeDelivery"
                    type="datetime"
                    class="w-full"
                    value-type="format"
                    :disabled="readonly"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>
                </section>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
              <b-form-group>
                <label>Cut off Date</label>

                <section>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.cutOffDate"
                    type="datetime"
                    class="w-full"
                    :disabled="readonly"
                    value-type="format"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>
                </section>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="PIC pick up"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>PIC pick up</label>
                  <b-form-input
                    placeholder="PIC pick up"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.PICPickUp"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="PIC Delivery"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>PIC Delivery</label>
                  <b-form-input
                    placeholder="PIC Delivery"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.PICDelivery"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" lg="4" class="pt-1">
              <h4>Other service</h4>
            </b-col>

            <b-col cols="3" class="pt-1">
              <b-form-checkbox
                :disabled="readonly"
                v-model="request_quotation.has_customs"
                >Customs services
              </b-form-checkbox>
            </b-col>
            <b-col cols="3" class="pt-1">
              <b-form-checkbox
                :disabled="readonly"
                v-model="request_quotation.has_container_trucking"
                >Container trucking</b-form-checkbox
              >
            </b-col>
          </b-row>
          <b-row v-if="request_quotation.has_customs">
            <b-col cols="12" lg="12" class="pt-1">
              <h4>Customs declaration information</h4>
            </b-col>

            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Customs type</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Customs type"
                  v-model="request_quotation.customs_type"
                  :options="customs_types"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Business type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Business type</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Business type"
                    v-model="request_quotation.business_type"
                    :options="business_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Place of Custom declaration"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Place of Custom declaration</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.customs_addr"
                    placeholder="Place of Custom declaration"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>HS Code </label>
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.hs_code"
                  placeholder="HS Code"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Notes</label>
                <b-form-textarea
                  :disabled="readonly"
                  rows="5"
                  v-model="request_quotation.notes"
                  placeholder="Notes"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            v-if="
              (step == 'booking' || step == 'view-quotation-booking') &&
              request_quotation.has_container_trucking
            "
          >
            <b-col cols="12">
              <b-form-group>
                <label>Billing information</label>
                <b-form-textarea
                  :disabled="readonly"
                  rows="5"
                  v-model="request_quotation.billingInformation"
                  placeholder="Billing information"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <!-- multi file upload starts -->
        </div>

        <!--LCL service_type = 3 -->
        <div v-if="request_quotation.service_type && request_quotation.service_type.toString() == '3'">
          <b-row>
            <b-col cols="12" class="pt-1">
              <h4>Freight Informations</h4>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                :name="request_quotation.service_type == 1 ? 'AOL' : 'POL'"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label
                    >{{ request_quotation.service_type == 1 ? "AOL" : "POL"
                    }}<font class="red">*</font>
                  </label>
                  <div class="d-flex">
                    <!-- <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="AOL/POL"
                      class="w-100"
                      v-model="request_quotation.pol_port"
                      :options="ports"
                    /> -->
                    <Select4
                      v-model="request_quotation.pol_port"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="AOL/POL"
                      :disabled="readonly"
                      :options="{
                        value: 'code',
                        label: 'name',
                        data: ports,
                        fields: [
                          {
                            field: 'code',
                            label: 'Code',
                          },
                          {
                            field: 'name',
                            label: 'Name',
                          },
                          {
                            field: 'country_code',
                            label: 'Country Code',
                          },
                        ],
                      }"
                    />
                    <!-- <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" :disabled="readonly"
                      @click.once="getDataPolPod" v-if="!isCustomer" v-b-tooltip.hover
                      title="Data synchronization with FAST" :key="buttonKey" class="btn-icon ml-1">
                      <feather-icon icon="RefreshCwIcon" />
                    </b-button> -->
                  </div>

                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                :name="request_quotation.service_type == 1 ? 'AOD' : 'POD'"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label
                    >{{ request_quotation.service_type == 1 ? "AOD" : "POD"
                    }}<font class="red">*</font></label
                  >

                  <!-- <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="AOD/POL"
                    v-model="request_quotation.pod_port"
                    :options="ports"
                  /> -->

                  <Select4
                    v-model="request_quotation.pod_port"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="AOD/POL"
                    :disabled="readonly"
                    :options="{
                      value: 'code',
                      label: 'name',
                      data: ports,
                      fields: [
                        {
                          field: 'code',
                          label: 'Code',
                        },
                        {
                          field: 'name',
                          label: 'Name',
                        },
                        {
                          field: 'country_code',
                          label: 'Country Code',
                        },
                      ],
                    }"
                  />

                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" :lg="4">
              <validation-provider
                name="Cargo ready"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Cargo ready<font class="red">*</font></label>
                  <div class="d-flex">
                    <date-picker
                      ref="datePicker"
                      v-model="request_quotation.cargo_ready"
                      type="datetime"
                      class="w-full"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      value-type="format"
                      :disabled="readonly"
                      title-format="DD/MM/YY"
                      time-title-format="DD/MM/YY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD/MM/YY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}
                        </button>
                      </template>
                    </date-picker>
                    <b-button
                      variant="primary"
                      v-if="!readonly"
                      type="button"
                      :disabled="readonly"
                      @click="modalSchedule = !modalSchedule"
                      class="btn ml-50 p-0"
                    >
                      Select schedule
                    </b-button>
                  </div>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              :lg="
                step == 'booking' || step == 'view-quotation-booking' ? 6 : 4
              "
            >
              <validation-provider
                name="Payment Terms"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Payment Terms</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Payment Terms"
                    v-model="request_quotation.paymentTerms"
                    :options="$Options.paymentTerms"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!--  Carrier -->

            <b-col
              cols="12"
              :lg="
                step == 'booking' || step == 'view-quotation-booking' ? 6 : 4
              "
            >
              <validation-provider
                name="Carrier"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Carrier</label>
                  <Select4
                    v-model="request_quotation.shipping_line"
                    :class="[
                      errors.length > 0 ? 'is-invalid' : null,
                      readonly == true ? 'remove' : '',
                    ]"
                    placeholder="Carrier"
                    :disabled="readonly"
                    :options="{
                      value: 'id',
                      label: 'text',
                      data: shipping_lines,
                      fields: [
                        {
                          field: 'code',
                          label: 'Code',
                        },
                        {
                          field: 'name',
                          label: 'Shipping Line',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              lg="4"
              v-if="step != 'view-quotation-booking' && step != 'booking'"
            >
              <b-form-group>
                <label>Volume (Monthly)</label>
                <!-- <Select2
                  :disabled="readonly"
                  placeholder="Volume (Monthly)"
                  v-model="request_quotation.volume"
                  :options="volumes"
                /> -->
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.volume"
                  placeholder="Volume (Monthly)"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="step == 'booking' || step == 'view-quotation-booking'">
            <b-col cols="6">
              <validation-provider name="ETD" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETD </label>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.etd"
                    type="date"
                    :title="request_quotation.etd"
                    class="w-full"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    value-type="format"
                    title-format="DD/MM/YY"
                    :disabled="readonly"
                    time-title-format="DD/MM/YY"
                    placeholder="Select date"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY"
                    @close="handleOpenChange"
                  >
                  </date-picker>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider name="ETA" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETA </label>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.eta"
                    type="date"
                    :title="request_quotation.eta"
                    class="w-full"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    value-type="format"
                    title-format="DD/MM/YY"
                    :disabled="readonly"
                    time-title-format="DD/MM/YY"
                    placeholder="Select date"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY"
                    @close="handleOpenChange"
                  >
                  </date-picker>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="pt-1">
              <h4>Cargo Information</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Commodity"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Commodity<font class="red">*</font></label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Commodity"
                    v-model="request_quotation.goods_type"
                    :options="goods_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Commodity description"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Commodity description</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.mo_ta"
                    placeholder="Commodity description"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Gross Weight (kgs)"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Total Gross Weight (kg)</label>
                  <cleave
                    :state="errors.length > 0 ? false : null"
                    :options="$Utils.CONSTANTS.cleaveNumeral"
                    :disabled="readonly"
                    v-model="request_quotation.trong_luong"
                    class="form-control"
                    placeholder="Gross Weight (kgs)"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- -->
          </b-row>
          <b-row>
            <b-col cols="12" lg="4">
              <b-form-group>
                <label>Measurement (cbm)</label>
                <cleave
                  :options="$Utils.CONSTANTS.cleaveNumeral"
                  :disabled="readonly"
                  v-model="request_quotation.so_khoi"
                  class="form-control"
                  placeholder="Measurement (kgs)"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Handled type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Handled type</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Handled type"
                    v-model="request_quotation.handled_type"
                    :options="handed_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" lg="4">
              <validation-provider
                name="Dimension"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Dimension</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.dimension"
                    placeholder="Dimension"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Package type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Package type</label>

                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Package type"
                    v-model="request_quotation.package_type"
                    :options="cont_types.filter((i) => i.group === 'packaging')"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" lg="6">
              <validation-provider
                name="Package Number"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Package Number</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.packageNumber"
                    placeholder="Package Number"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row v-if="request_quotation.has_van_trucking">
            <b-col cols="12" class="pt-1">
              <h4>Shipment Informations</h4>
            </b-col>
          </b-row>
          <b-row
            v-if="
              (step == 'booking' || step == 'view-quotation-booking') &&
              request_quotation.has_van_trucking
            "
          >
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Booking/HBL/INV</label>
                <b-form-input
                  :disabled="readonly"
                  placeholder="Booking/HBL/INV"
                  v-model="request_quotation.HBL"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Shipping Type</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Shipping Type"
                  v-model="request_quotation.shippingType"
                  :options="
                    request_quotation.service_type == 5
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : request_quotation.service_type == 6
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : transport_types.filter((i) => [1, 2].includes(i.id))
                  "
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="request_quotation.has_van_trucking">
            <b-col cols="12" lg="6">
              <validation-provider
                name="Truck Type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Truck Type</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Truck Type"
                    v-model="request_quotation.truck_type"
                    :options="cont_types.filter((i) => i.group === 'van truck')"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Quantity"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Quantity</label>
                  <b-form-input
                    placeholder="Quantity"
                    type="number"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.so_luong"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <section v-if="request_quotation.has_van_trucking">
            <b-row
              v-if="
                step == 'created-quotation' ||
                step == 'view-created-quotation' ||
                (step == 'view-quotation-booking' &&
                  (request_quotation.pickup_region != null ||
                    request_quotation.other_pickup_region) &&
                  step != 'booking')
              "
            >
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Pick up"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Pick up<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select2
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="hide_select"
                        :disabled="readonly"
                        v-if="!request_quotation.isHideShows"
                        placeholder="Pick up"
                        v-model="request_quotation.pickup_region"
                        :options="regions"
                      />
                      <b-form-input
                        v-if="request_quotation.isHideShows"
                        :disabled="readonly"
                        v-model="request_quotation.other_pickup_region"
                        placeholder="Enter pick up "
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsi"
                        v-model="request_quotation.isHideShows"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Delivery"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Delivery<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select2
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="hide_select"
                        :disabled="readonly"
                        placeholder="Delivery"
                        v-if="!request_quotation.isHideShowPk"
                        v-model="request_quotation.delivery_region"
                        :options="regions"
                      />
                      <b-form-input
                        :disabled="readonly"
                        v-if="request_quotation.isHideShowPk"
                        v-model="request_quotation.other_delivery_region"
                        placeholder="Enter pick up"
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsPk"
                        v-model="request_quotation.isHideShowPk"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row v-else>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Pick up"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Pick up<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select4
                        v-model="request_quotation.pickup_location"
                        :key="countRq"
                        :class="
                          errors.length > 0
                            ? 'is-invalid hide_select'
                            : 'hide_select'
                        "
                        placeholder="Enter Pick up "
                        v-if="!request_quotation.isHideShows"
                        :disabled="readonly"
                        :options="{
                          value: 'id',
                          label: 'text',
                          data: locations,
                          fields: [
                            {
                              field: 'abbreviations',
                              label: 'Abbreviations',
                            },
                            {
                              field: 'name',
                              label: 'Location',
                            },
                            {
                              field: 'address',
                              label: 'Address',
                            },
                          ],
                        }"
                      />
                      <b-form-input
                        :disabled="readonly"
                        v-if="request_quotation.isHideShows"
                        v-model="request_quotation.other_pickup_location"
                        placeholder="Enter pick up "
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsi"
                        v-model="request_quotation.isHideShows"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Delivery"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Delivery<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select4
                        v-model="request_quotation.delivery_location"
                        :key="countRq"
                        :class="
                          errors.length > 0
                            ? 'is-invalid hide_select'
                            : 'hide_select'
                        "
                        placeholder="Enter Delivery "
                        v-if="!request_quotation.isHideShowPk"
                        :disabled="readonly"
                        :options="{
                          value: 'id',
                          label: 'text',
                          data: locations,
                          fields: [
                            {
                              field: 'abbreviations',
                              label: 'Abbreviations',
                            },
                            {
                              field: 'name',
                              label: 'Location',
                            },
                            {
                              field: 'address',
                              label: 'Address',
                            },
                          ],
                        }"
                      />
                      <b-form-input
                        v-if="request_quotation.isHideShowPk"
                        :disabled="readonly"
                        v-model="request_quotation.other_delivery_location"
                        placeholder="Enter pick up"
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsPk"
                        v-model="request_quotation.isHideShowPk"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </section>

          <b-row
            v-if="
              request_quotation.has_van_trucking &&
              (step == 'booking' || step == 'view-quotation-booking')
            "
          >
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Pick up date</label>

                <section>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.pick_up_date"
                    type="datetime"
                    class="w-full"
                    :disabled="readonly"
                    value-type="format"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>
                </section>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Delivery Date</label>

                <section>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.delivery_date"
                    :disabled-date="disabledRangeDelivery"
                    type="datetime"
                    class="w-full"
                    value-type="format"
                    :disabled="readonly"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>
                </section>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="PIC pick up"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>PIC pick up</label>
                  <b-form-input
                    placeholder="PIC pick up"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.PICPickUp"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="PIC Delivery"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>PIC Delivery</label>
                  <b-form-input
                    placeholder="PIC Delivery"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.PICDelivery"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row v-if="request_quotation.service_type == 1">
            <b-col cols="12" class="pt-1">
              <h4>Intended schedule</h4>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="From"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>From<font class="red">*</font></label>
                  <b-form-datepicker
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.from_date"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="To"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>To<font class="red">*</font></label>
                  <b-form-datepicker
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.to_date"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="4" class="pt-1">
              <h4>Other service</h4>
            </b-col>
            <b-col cols="3" class="pt-1">
              <b-form-checkbox
                :disabled="readonly"
                v-model="request_quotation.has_customs"
                >Customs services
              </b-form-checkbox>
            </b-col>
            <b-col cols="3" class="pt-1">
              <b-form-checkbox
                :disabled="readonly"
                v-model="request_quotation.has_van_trucking"
                >Van trucking
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row v-if="request_quotation.has_customs">
            <b-col cols="12" lg="12" class="pt-1">
              <h4>Customs declaration information</h4>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Customs type</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Customs type"
                  v-model="request_quotation.customs_type"
                  :options="customs_types"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Business type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Business type</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Business type"
                    v-model="request_quotation.business_type"
                    :options="business_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Place of Custom declaration"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Place of Custom declaration</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.customs_addr"
                    placeholder="Place of Custom declaration"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>HS Code</label>
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.hs_code"
                  placeholder="HS Code"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Notes</label>
                <b-form-textarea
                  rows="5"
                  :disabled="readonly"
                  v-model="request_quotation.notes"
                  placeholder="Notes"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <!-- multi file upload starts -->
        </div>
        <!-- + Air-->
        <div v-if="request_quotation.service_type &&  request_quotation.service_type.toString() == '1'">
          <b-row>
            <b-col cols="12" class="pt-1">
              <h4>Freight Informations</h4>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                :name="request_quotation.service_type == 1 ? 'AOL' : 'POL'"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label
                    >{{ request_quotation.service_type == 1 ? "AOL" : "POL"
                    }}<font class="red">*</font>
                  </label>
                  <div class="d-flex">
                    <!-- <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="AOL/POL"
                      class="w-100"
                      v-model="request_quotation.pol_port"
                      :options="ports"
                    /> -->
                    <Select4
                      v-model="request_quotation.pol_port"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="AOL/POL"
                      :disabled="readonly"
                      :options="{
                        value: 'code',
                        label: 'name',
                        data: ports,
                        fields: [
                          {
                            field: 'code',
                            label: 'Code',
                          },
                          {
                            field: 'name',
                            label: 'Name',
                          },
                          {
                            field: 'country_code',
                            label: 'Country Code',
                          },
                        ],
                      }"
                    />
                    <!-- <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" :disabled="readonly"
                      @click.once="getDataPolPod" v-if="!isCustomer" v-b-tooltip.hover
                      title="Data synchronization with FAST" :key="buttonKey" class="btn-icon ml-1">
                      <feather-icon icon="RefreshCwIcon" />
                    </b-button> -->
                  </div>

                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                :name="request_quotation.service_type == 1 ? 'AOD' : 'POD'"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label
                    >{{ request_quotation.service_type == 1 ? "AOD" : "POD"
                    }}<font class="red">*</font></label
                  >

                  <!-- <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="AOD/POL"
                    v-model="request_quotation.pod_port"
                    :options="ports"
                  /> -->
                  <Select4
                    v-model="request_quotation.pod_port"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="AOD/POL"
                    :disabled="readonly"
                    :options="{
                      value: 'code',
                      label: 'name',
                      data: ports,
                      fields: [
                        {
                          field: 'code',
                          label: 'Code',
                        },
                        {
                          field: 'name',
                          label: 'Name',
                        },
                        {
                          field: 'country_code',
                          label: 'Country Code',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" :lg="4">
              <validation-provider
                name="Cargo ready"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Cargo ready<font class="red">*</font></label>

                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.cargo_ready"
                    type="datetime"
                    class="w-full"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    value-type="format"
                    :disabled="readonly"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>

                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              :lg="
                step == 'booking' || step == 'view-quotation-booking' ? 6 : 4
              "
            >
              <validation-provider
                name="Payment Terms"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Payment Terms</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Payment Terms"
                    v-model="request_quotation.paymentTerms"
                    :options="$Options.paymentTerms"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!--  Carrier -->

            <b-col
              cols="12"
              :lg="
                step == 'booking' || step == 'view-quotation-booking' ? 6 : 4
              "
            >
              <validation-provider
                name="Airline"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Airline</label>

                  <Select4
                    v-model="request_quotation.shipping_line"
                    :class="[
                      errors.length > 0 ? 'is-invalid' : null,
                      readonly == true ? 'remove' : '',
                    ]"
                    placeholder="Airline"
                    :disabled="readonly"
                    :options="{
                      value: 'id',
                      label: 'text',
                      data: shipping_lines,
                      fields: [
                        {
                          field: 'code',
                          label: 'Code',
                        },
                        {
                          field: 'name',
                          label: 'Shipping Line',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              lg="4"
              v-if="step != 'view-quotation-booking' && step != 'booking'"
            >
              <b-form-group>
                <label>Volume (Monthly)</label>
                <!-- <Select2
                  :disabled="readonly"
                  placeholder="Volume (Monthly)"
                  v-model="request_quotation.volume"
                  :options="volumes"
                /> -->
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.volume"
                  placeholder="Volume (Monthly)"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="step == 'booking' || step == 'view-quotation-booking'">
            <b-col cols="6">
              <validation-provider name="ETD" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETD </label>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.etd"
                    type="date"
                    :title="request_quotation.etd"
                    class="w-full"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    value-type="format"
                    title-format="DD/MM/YY"
                    :disabled="readonly"
                    time-title-format="DD/MM/YY"
                    placeholder="Select date"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY"
                    @close="handleOpenChange"
                  >
                  </date-picker>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider name="ETA" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETA </label>
                  <!-- <b-form-datepicker
                    :state="errors.length > 0 ? false : null"
                    v-model="request_quotation.eta"
                    :disabled="readonly"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  /> -->
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.eta"
                    type="date"
                    :title="request_quotation.eta"
                    class="w-full"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    value-type="format"
                    title-format="DD/MM/YY"
                    :disabled="readonly"
                    time-title-format="DD/MM/YY"
                    placeholder="Select date"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY"
                    @close="handleOpenChange"
                  >
                  </date-picker>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="pt-1">
              <h4>Cargo Information</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Commodity"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Commodity<font class="red">*</font></label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Commodity"
                    v-model="request_quotation.goods_type"
                    :options="goods_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Commodity description"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Commodity description</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.mo_ta"
                    placeholder="Commodity description"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Gross Weight (kgs)"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Total Gross Weight (kg)</label>

                  <cleave
                    :state="errors.length > 0 ? false : null"
                    :options="$Utils.CONSTANTS.cleaveNumeral"
                    :disabled="readonly"
                    v-model="request_quotation.trong_luong"
                    class="form-control"
                    placeholder="Gross Weight (kgs)"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- -->
          </b-row>
          <b-row>
            <b-col cols="12" lg="4">
              <b-form-group>
                <label>Measurement (cbm)</label>
                <cleave
                  :options="$Utils.CONSTANTS.cleaveNumeral"
                  :disabled="readonly"
                  v-model="request_quotation.so_khoi"
                  class="form-control"
                  placeholder="Measurement (kgs)"
                />
                <!-- <b-form-input
                  type="number"
                  :disabled="readonly"
                  v-model="request_quotation.so_khoi"
                  placeholder="Measurement (kgs)"
                /> -->
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Handled type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Handled type</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Handled type"
                    v-model="request_quotation.handled_type"
                    :options="handed_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" lg="4">
              <validation-provider
                name="Total Charge Weight (kg)"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Total Charge Weight (kg)</label>
                  <cleave
                    :options="$Utils.CONSTANTS.cleaveNumeral"
                    :state="errors.length > 0 ? false : null"
                    :disabled="true"
                    v-model="request_quotation.totalChargeWeight"
                    class="form-control"
                    placeholder="Total Charge Weight (kg)"
                  />
                  <!-- <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.totalChargeWeight"
                    placeholder="Total Charge Weight (kg)"
                  /> -->
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Package type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Package type</label>

                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Package type"
                    v-model="request_quotation.package_type"
                    :options="cont_types.filter((i) => i.group === 'packaging')"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" lg="6">
              <validation-provider
                name="Package Number"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Package Number</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.packageNumber"
                    placeholder="Package Number"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row v-if="request_quotation.has_van_trucking">
            <b-col cols="12" class="pt-1">
              <h4>Shipment Informations</h4>
            </b-col>
          </b-row>
          <b-row
            v-if="
              (step == 'booking' || step == 'view-quotation-booking') &&
              request_quotation.has_van_trucking
            "
          >
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Booking/HBL/INV</label>
                <b-form-input
                  :disabled="readonly"
                  placeholder="Booking/HBL/INV"
                  v-model="request_quotation.HBL"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Shipping Type</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Shipping Type"
                  v-model="request_quotation.shippingType"
                  :options="
                    request_quotation.service_type == 5
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : request_quotation.service_type == 6
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : transport_types.filter((i) => [1, 2].includes(i.id))
                  "
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="request_quotation.has_van_trucking">
            <b-col cols="12" lg="6">
              <validation-provider
                name="Truck Type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Truck Type</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Truck Type"
                    v-model="request_quotation.truck_type"
                    :options="cont_types.filter((i) => i.group === 'van truck')"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Quantity"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Quantity</label>
                  <cleave
                    :options="$Utils.CONSTANTS.cleaveNumeral"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.so_luong"
                    class="form-control"
                    placeholder="Quantity"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <section v-if="request_quotation.has_van_trucking">
            <b-row
              v-if="
                step == 'created-quotation' ||
                step == 'view-created-quotation' ||
                (step == 'view-quotation-booking' &&
                  (request_quotation.pickup_region != null ||
                    request_quotation.other_pickup_region) &&
                  step != 'booking')
              "
            >
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Pick up"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Pick up<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select2
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="hide_select"
                        :disabled="readonly"
                        v-if="!request_quotation.isHideShows"
                        placeholder="Pick up"
                        v-model="request_quotation.pickup_region"
                        :options="regions"
                      />
                      <b-form-input
                        v-if="request_quotation.isHideShows"
                        :disabled="readonly"
                        v-model="request_quotation.other_pickup_region"
                        placeholder="Enter pick up "
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsi"
                        v-model="request_quotation.isHideShows"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Delivery"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Delivery<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select2
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="hide_select"
                        :disabled="readonly"
                        placeholder="Delivery"
                        v-if="!request_quotation.isHideShowPk"
                        v-model="request_quotation.delivery_region"
                        :options="regions"
                      />
                      <b-form-input
                        :disabled="readonly"
                        v-if="request_quotation.isHideShowPk"
                        v-model="request_quotation.other_delivery_region"
                        placeholder="Enter pick up"
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsPk"
                        v-model="request_quotation.isHideShowPk"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row v-else>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Pick up"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Pick up<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select4
                        v-model="request_quotation.pickup_location"
                        :key="countRq"
                        :class="
                          errors.length > 0
                            ? 'is-invalid hide_select'
                            : 'hide_select'
                        "
                        placeholder="Enter Pick up "
                        v-if="!request_quotation.isHideShows"
                        :disabled="readonly"
                        :options="{
                          value: 'id',
                          label: 'text',
                          data: locations,
                          fields: [
                            {
                              field: 'abbreviations',
                              label: 'Abbreviations',
                            },
                            {
                              field: 'name',
                              label: 'Location',
                            },
                            {
                              field: 'address',
                              label: 'Address',
                            },
                          ],
                        }"
                      />
                      <b-form-input
                        :disabled="readonly"
                        v-if="request_quotation.isHideShows"
                        v-model="request_quotation.other_pickup_location"
                        placeholder="Enter pick up "
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsi"
                        v-model="request_quotation.isHideShows"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Delivery"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Delivery<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select4
                        v-model="request_quotation.delivery_location"
                        :key="countRq"
                        :class="
                          errors.length > 0
                            ? 'is-invalid hide_select'
                            : 'hide_select'
                        "
                        placeholder="Enter Delivery "
                        v-if="!request_quotation.isHideShowPk"
                        :disabled="readonly"
                        :options="{
                          value: 'id',
                          label: 'text',
                          data: locations,
                          fields: [
                            {
                              field: 'abbreviations',
                              label: 'Abbreviations',
                            },
                            {
                              field: 'name',
                              label: 'Location',
                            },
                            {
                              field: 'address',
                              label: 'Address',
                            },
                          ],
                        }"
                      />
                      <b-form-input
                        v-if="request_quotation.isHideShowPk"
                        :disabled="readonly"
                        v-model="request_quotation.other_delivery_location"
                        placeholder="Enter pick up"
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsPk"
                        v-model="request_quotation.isHideShowPk"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </section>
          <b-row
            v-if="
              request_quotation.has_van_trucking &&
              (step == 'booking' || step == 'view-quotation-booking')
            "
          >
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Pick up date</label>

                <section>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.pick_up_date"
                    type="datetime"
                    class="w-full"
                    :disabled="readonly"
                    value-type="format"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>
                </section>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Delivery Date</label>

                <section>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.delivery_date"
                    :disabled-date="disabledRangeDelivery"
                    type="datetime"
                    class="w-full"
                    value-type="format"
                    :disabled="readonly"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>
                </section>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="PIC pick up"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>PIC pick up</label>
                  <b-form-input
                    placeholder="PIC pick up"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.PICPickUp"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="PIC Delivery"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>PIC Delivery</label>
                  <b-form-input
                    placeholder="PIC Delivery"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.PICDelivery"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="4" class="pt-1">
              <h4>Other service</h4>
            </b-col>
            <b-col cols="3" class="pt-1">
              <b-form-checkbox
                :disabled="readonly"
                v-model="request_quotation.has_customs"
                >Customs services
              </b-form-checkbox>
            </b-col>
            <b-col cols="3" class="pt-1">
              <b-form-checkbox
                :disabled="readonly"
                v-model="request_quotation.has_van_trucking"
                >Van trucking
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row v-if="request_quotation.has_customs">
            <b-col cols="12" lg="12" class="pt-1">
              <h4>Customs declaration information</h4>
            </b-col>

            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Customs type</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Customs type"
                  v-model="request_quotation.customs_type"
                  :options="customs_types"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Business type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Business type</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Business type"
                    v-model="request_quotation.business_type"
                    :options="business_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Place of Custom declaration"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Place of Custom declaration</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.customs_addr"
                    placeholder="Place of Custom declaration"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>HS Code</label>
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.hs_code"
                  placeholder="HS Code"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Notes</label>
                <b-form-textarea
                  rows="5"
                  :disabled="readonly"
                  v-model="request_quotation.notes"
                  placeholder="Notes"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <!-- multi file upload starts -->
        </div>

        <!--Container Trucking-->
        <div v-if="request_quotation.service_type == 5">
          <b-row>
            <b-col cols="12" class="pt-1">
              <h4>Shipment Informations</h4>
            </b-col>
          </b-row>
          <b-row v-if="step == 'booking' || step == 'view-quotation-booking'">
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Booking/HBL/INV</label>
                <b-form-input
                  :disabled="readonly"
                  placeholder="Booking/HBL/INV"
                  v-model="request_quotation.HBL"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Shipping Type</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Shipping Type"
                  v-model="request_quotation.shippingType"
                  :options="
                    request_quotation.service_type == 5
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : request_quotation.service_type == 6
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : transport_types.filter((i) => [1, 2].includes(i.id))
                  "
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Container Type"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Container Type <font class="red">*</font></label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Container Type"
                    v-model="request_quotation.cont_type"
                    :options="
                      cont_types.filter((i) => i.group === 'Container truck')
                    "
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Quantity"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Quantity</label>
                  <cleave
                    :options="$Utils.CONSTANTS.cleaveNumeral"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.so_luong"
                    class="form-control"
                    placeholder="Quantity"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              lg="6"
              v-if="step == 'booking' || step == 'view-quotation-booking'"
            >
              <b-form-group>
                <label>Container No.</label>
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.container_no"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              lg="6"
              v-if="step == 'booking' || step == 'view-quotation-booking'"
            >
              <b-form-group>
                <label>Seal</label>
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.seal_no"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              :lg="
                step == 'booking' || step == 'view-quotation-booking'
                  ? '6'
                  : '4'
              "
              v-if="
                step == 'created-quotation' ||
                step == 'view-created-quotation' ||
                (step == 'view-quotation-booking' &&
                  (request_quotation.pickup_region != null ||
                    request_quotation.other_pickup_region) &&
                  step != 'booking')
              "
            >
              <validation-provider
                name="Pick up"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Pick up<font class="red">*</font></label>
                  <div class="d-flex align-items-center">
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      class="hide_select"
                      v-if="!request_quotation.isHideShows"
                      :disabled="readonly"
                      placeholder="Pick up"
                      v-model="request_quotation.pickup_region"
                      :options="regions"
                    />
                    <b-form-input
                      v-if="request_quotation.isHideShows"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      v-model="request_quotation.other_pickup_region"
                      placeholder="Enter pick up "
                    />
                    <b-form-checkbox
                      :disabled="readonly"
                      v-on:change="hideShowsi"
                      v-model="request_quotation.isHideShows"
                      class="check_input"
                      >Other
                    </b-form-checkbox>
                  </div>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              :lg="
                step == 'booking' || step == 'view-quotation-booking'
                  ? '6'
                  : '4'
              "
              v-if="
                step == 'created-quotation' ||
                step == 'view-created-quotation' ||
                (step == 'view-quotation-booking' &&
                  (request_quotation.delivery_region != null ||
                    request_quotation.other_delivery_region) &&
                  step != 'booking')
              "
            >
              <validation-provider
                name="Delivery"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Delivery<font class="red">*</font></label>
                  <div class="d-flex align-items-center">
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      class="hide_select"
                      v-if="!request_quotation.isHideShowPk"
                      :disabled="readonly"
                      placeholder="Delivery"
                      v-model="request_quotation.delivery_region"
                      :options="regions"
                    />
                    <b-form-input
                      :disabled="readonly"
                      v-if="request_quotation.isHideShowPk"
                      v-model="request_quotation.other_delivery_region"
                      placeholder="Enter pick up"
                    />
                    <b-form-checkbox
                      :disabled="readonly"
                      v-on:change="hideShowsPk"
                      v-model="request_quotation.isHideShowPk"
                      class="check_input"
                      >Other
                    </b-form-checkbox>
                  </div>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              :lg="
                step == 'booking' || step == 'view-quotation-booking'
                  ? '6'
                  : '4'
              "
              v-if="
                (step != 'created-quotation' &&
                  step != 'view-created-quotation' &&
                  step == 'view-quotation-booking' &&
                  (request_quotation.pickup_location != null ||
                    request_quotation.other_pickup_location != null)) ||
                step == 'booking'
              "
            >
              <validation-provider
                name="Pick up"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Pick up<font class="red">*</font></label>
                  <div class="d-flex align-items-center">
                    <Select4
                      :key="countRq"
                      v-model="request_quotation.pickup_location"
                      :class="
                        errors.length > 0
                          ? 'is-invalid hide_select'
                          : 'hide_select'
                      "
                      :disabled="readonly"
                      placeholder="Enter Pick up "
                      v-if="!request_quotation.isHideShows"
                      :options="{
                        value: 'id',
                        label: 'text',
                        data: locations,
                        fields: [
                          {
                            field: 'abbreviations',
                            label: 'Abbreviations',
                          },
                          {
                            field: 'name',
                            label: 'Location',
                          },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <b-form-input
                      v-if="request_quotation.isHideShows"
                      :disabled="readonly"
                      v-model="request_quotation.other_pickup_location"
                      placeholder="Enter pick up "
                    />
                    <b-form-checkbox
                      :disabled="readonly"
                      v-on:change="hideShowsi"
                      v-model="request_quotation.isHideShows"
                      class="check_input"
                      >Other
                    </b-form-checkbox>
                  </div>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              :lg="
                step == 'booking' || step == 'view-quotation-booking'
                  ? '6'
                  : '4'
              "
              v-if="
                (step != 'created-quotation' &&
                  step != 'view-created-quotation' &&
                  step == 'view-quotation-booking' &&
                  (request_quotation.delivery_location != null ||
                    request_quotation.other_delivery_location != null)) ||
                step == 'booking'
              "
            >
              <validation-provider
                name="Delivery"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Delivery<font class="red">*</font></label>
                  <div class="d-flex align-items-center">
                    <Select4
                      v-model="request_quotation.delivery_location"
                      :key="countRq"
                      :class="
                        errors.length > 0
                          ? 'is-invalid hide_select'
                          : 'hide_select'
                      "
                      placeholder="Enter Delivery "
                      v-if="!request_quotation.isHideShowPk"
                      :disabled="readonly"
                      :options="{
                        value: 'id',
                        label: 'text',
                        data: locations,
                        fields: [
                          {
                            field: 'abbreviations',
                            label: 'Abbreviations',
                          },
                          {
                            field: 'name',
                            label: 'Location',
                          },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <b-form-input
                      :disabled="readonly"
                      v-if="request_quotation.isHideShowPk"
                      v-model="request_quotation.other_delivery_location"
                      placeholder="Enter pick up"
                    />
                    <b-form-checkbox
                      :disabled="readonly"
                      v-on:change="hideShowsPk"
                      v-model="request_quotation.isHideShowPk"
                      class="check_input"
                      >Other
                    </b-form-checkbox>
                  </div>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              :lg="
                step == 'booking' || step == 'view-quotation-booking'
                  ? '6'
                  : '4'
              "
              v-if="
                (step != 'created-quotation' &&
                  step != 'view-created-quotation' &&
                  step == 'view-quotation-booking' &&
                  request_quotation.deport_location != null) ||
                step == 'booking'
              "
            >
              <b-form-group>
                <label>Empty depot </label>

                <Select4
                  v-model="request_quotation.deport_location"
                  placeholder="Empty depot"
                  :disabled="readonly"
                  :options="{
                    value: 'id',
                    label: 'text',
                    data: locationsNoService,
                    fields: [
                      {
                        field: 'abbreviations',
                        label: 'Abbreviations',
                      },
                      {
                        field: 'name',
                        label: 'Location',
                      },
                      {
                        field: 'address',
                        label: 'Address',
                      },
                    ],
                  }"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              :lg="
                step == 'booking' || step == 'view-quotation-booking'
                  ? '6'
                  : '4'
              "
              v-else
            >
              <b-form-group>
                <label>Empty depot</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Empty depot"
                  v-model="request_quotation.deport"
                  :options="regions"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              lg="6"
              v-if="step == 'booking' || step == 'view-quotation-booking'"
            >
              <b-form-group>
                <label>Cut off Date</label>

                <section>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.cutOffDate"
                    type="datetime"
                    class="w-full"
                    :disabled="readonly"
                    value-type="format"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>
                </section>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              lg="6"
              v-if="step == 'booking' || step == 'view-quotation-booking'"
            >
              <b-form-group>
                <label>Pick up date</label>

                <section>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.pick_up_date"
                    type="datetime"
                    class="w-full"
                    :disabled="readonly"
                    value-type="format"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>
                </section>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              lg="6"
              v-if="step == 'booking' || step == 'view-quotation-booking'"
            >
              <b-form-group>
                <label>Delivery Date</label>

                <section>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.delivery_date"
                    :disabled-date="disabledRangeDelivery"
                    type="datetime"
                    class="w-full"
                    value-type="format"
                    :disabled="readonly"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>
                </section>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              lg="6"
              v-if="step == 'booking' || step == 'view-quotation-booking'"
            >
              <validation-provider
                name="PIC pick up"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>PIC pick up</label>
                  <b-form-input
                    placeholder="PIC pick up"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.PICPickUp"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              lg="6"
              v-if="step == 'booking' || step == 'view-quotation-booking'"
            >
              <validation-provider
                name="PIC Delivery"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>PIC Delivery</label>
                  <b-form-input
                    placeholder="PIC Delivery"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.PICDelivery"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              :lg="
                step == 'booking' || step == 'view-quotation-booking' ? 12 : 6
              "
            >
              <b-col
                :lg="
                  step == 'booking' || step == 'view-quotation-booking' ? 12 : 6
                "
                class="pt-1 pl-0"
              >
                <h4>Freight Informations</h4>
              </b-col>
              <b-col
                lg="
                  12
                "
              >
                <b-form-group
                  v-if="step == 'booking' || step == 'view-quotation-booking'"
                >
                  <label>Carriers </label>

                  <Select4
                    v-model="request_quotation.shipping_line"
                    placeholder="Carriers"
                    :disabled="readonly"
                    :options="{
                      value: 'id',
                      label: 'text',
                      data: shipping_lines,
                      fields: [
                        {
                          field: 'code',
                          label: 'Code',
                        },
                        {
                          field: 'name',
                          label: 'Shipping Line',
                        },
                      ],
                    }"
                  />
                </b-form-group>
                <b-form-group v-else>
                  <label>Volume (Monthly)</label>

                  <b-form-input
                    :disabled="readonly"
                    v-model="request_quotation.volume"
                    placeholder="Volume (Monthly)"
                  />
                </b-form-group>
              </b-col>
            </b-col>
            <b-col
              :lg="
                step == 'booking' || step == 'view-quotation-booking' ? 12 : 6
              "
            >
              <b-col
                :lg="
                  step == 'booking' || step == 'view-quotation-booking' ? 12 : 6
                "
                class="pt-1 pl-0"
              >
                <h4>Cargo Information</h4>
              </b-col>

              <b-row>
                <b-col
                  :lg="
                    step == 'booking' || step == 'view-quotation-booking'
                      ? 6
                      : 12
                  "
                >
                  <validation-provider
                    name="Commodity"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label>Commodity<font class="red">*</font></label>
                      <Select2
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        :disabled="readonly"
                        placeholder="Commodity"
                        v-model="request_quotation.goods_type"
                        :options="goods_types"
                      />
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col
                  v-if="step == 'booking' || step == 'view-quotation-booking'"
                  cols="12"
                  lg="6"
                >
                  <validation-provider
                    name="Gross Weight (kgs)"
                    #default="{ errors }"
                    rules=""
                  >
                    <b-form-group>
                      <label>Total Gross Weight (kg)</label>

                      <cleave
                        :state="errors.length > 0 ? false : null"
                        :options="$Utils.CONSTANTS.cleaveNumeral"
                        :disabled="readonly"
                        v-model="request_quotation.trong_luong"
                        class="form-control"
                        placeholder="Gross Weight (kgs)"
                      />
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" lg="4" class="pt-1">
              <h4>Other service</h4>
            </b-col>
            <b-col cols="3" class="pt-1">
              <b-form-checkbox
                :disabled="readonly"
                v-model="request_quotation.has_customs"
                >Customs services
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row v-if="request_quotation.has_customs">
            <b-col lg="12" class="pt-1">
              <h4>Customs declaration information</h4>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Customs type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Customs type</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Customs type"
                    v-model="request_quotation.customs_type"
                    :options="customs_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Business type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Business type </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Business type"
                    v-model="request_quotation.business_type"
                    :options="business_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Place of Custom declaration"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Place of Custom declaration </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.customs_addr"
                    placeholder="Place of Custom declaration"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>HS Code</label>
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.hs_code"
                  placeholder="HS Code"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Notes</label>
                <b-form-textarea
                  :disabled="readonly"
                  rows="5"
                  v-model="request_quotation.notes"
                  placeholder="Notes"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="step == 'booking' || step == 'view-quotation-booking'">
            <b-col cols="12">
              <b-form-group>
                <label>Billing information</label>
                <b-form-textarea
                  :disabled="readonly"
                  rows="5"
                  v-model="request_quotation.billingInformation"
                  placeholder="Billing information"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <!--Van Trucking-->
        <div v-if="request_quotation.service_type == 6">
          <b-row>
            <b-col cols="12" class="pt-1">
              <h4>Shipment Informations</h4>
            </b-col>
          </b-row>
          <b-row v-if="step == 'booking' || step == 'view-quotation-booking'">
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Booking/HBL/INV</label>
                <b-form-input
                  :disabled="readonly"
                  placeholder="Booking/HBL/INV"
                  v-model="request_quotation.HBL"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Shipping Type</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Shipping Type"
                  v-model="request_quotation.shippingType"
                  :options="
                    request_quotation.service_type == 5
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : request_quotation.service_type == 6
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : transport_types.filter((i) => [1, 2].includes(i.id))
                  "
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Truck Type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Truck Type</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Truck Type"
                    v-model="request_quotation.truck_type"
                    :options="cont_types.filter((i) => i.group === 'van truck')"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Quantity"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Quantity</label>
                  <cleave
                    :options="$Utils.CONSTANTS.cleaveNumeral"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.so_luong"
                    class="form-control"
                    placeholder="Quantity"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row
            v-if="
              step == 'created-quotation' ||
              step == 'view-created-quotation' ||
              (step == 'view-quotation-booking' &&
                (request_quotation.pickup_region != null ||
                  request_quotation.other_pickup_region) &&
                step != 'booking')
            "
          >
            <b-col :cols="6">
              <validation-provider
                name="Pick up"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Pick up<font class="red">*</font></label>
                  <div class="d-flex align-items-center">
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      class="hide_select"
                      v-if="!request_quotation.isHideShows"
                      :disabled="readonly"
                      placeholder="Pick up"
                      v-model="request_quotation.pickup_region"
                      :options="regions"
                    />
                    <b-form-input
                      v-if="request_quotation.isHideShows"
                      :disabled="readonly"
                      v-model="request_quotation.other_pickup_region"
                      placeholder="Enter pick up "
                    />
                    <b-form-checkbox
                      :disabled="readonly"
                      v-on:change="hideShowsi"
                      v-model="request_quotation.isHideShows"
                      class="check_input"
                      >Other
                    </b-form-checkbox>
                  </div>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col :cols="6">
              <validation-provider
                name="Delivery"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Delivery<font class="red">*</font></label>
                  <div class="d-flex align-items-center">
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      class="hide_select"
                      v-if="!request_quotation.isHideShowPk"
                      :disabled="readonly"
                      placeholder="Delivery"
                      v-model="request_quotation.delivery_region"
                      :options="regions"
                    />
                    <b-form-input
                      v-else
                      :disabled="readonly"
                      v-model="request_quotation.other_delivery_region"
                      placeholder="Enter pick up"
                    />
                    <b-form-checkbox
                      :disabled="readonly"
                      v-on:change="hideShowsPk"
                      v-model="request_quotation.isHideShowPk"
                      class="check_input"
                      >Other
                    </b-form-checkbox>
                  </div>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- <b-col cols="12" lg="4" v-if="step == 'view-quotation-booking'">
              <b-form-group>
                <label>Shipping Type </label>
                <Select2
                  :disabled="readonly"
                  placeholder="Shipping Type"
                  v-model="request_quotation.shippingType"
                  :options="
                    request_quotation.service_type == 5
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : request_quotation.service_type == 6
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : transport_types.filter((i) => [1, 2].includes(i.id))
                  "
                />
              </b-form-group>
            </b-col> -->
          </b-row>

          <b-row v-else>
            <b-col :cols="6">
              <validation-provider
                name="Pick up"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Pick up<font class="red">*</font></label>
                  <div class="d-flex align-items-center">
                    <Select4
                      v-model="request_quotation.pickup_location"
                      :key="countRq"
                      :class="
                        errors.length > 0
                          ? 'is-invalid hide_select'
                          : 'hide_select'
                      "
                      placeholder="Enter Pick up "
                      v-if="!request_quotation.isHideShows"
                      :disabled="readonly"
                      :options="{
                        value: 'id',
                        label: 'text',
                        data: locations,
                        fields: [
                          {
                            field: 'abbreviations',
                            label: 'Abbreviations',
                          },
                          {
                            field: 'name',
                            label: 'Location',
                          },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <b-form-input
                      :disabled="readonly"
                      v-if="request_quotation.isHideShows"
                      v-model="request_quotation.other_pickup_location"
                      placeholder="Enter pick up "
                    />
                    <b-form-checkbox
                      :disabled="readonly"
                      v-on:change="hideShowsi"
                      v-model="request_quotation.isHideShows"
                      class="check_input"
                      >Other
                    </b-form-checkbox>
                  </div>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col :cols="6">
              <validation-provider
                name="Delivery"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Delivery<font class="red">*</font></label>
                  <div class="d-flex align-items-center">
                    <Select4
                      v-model="request_quotation.delivery_location"
                      :key="countRq"
                      :class="
                        errors.length > 0
                          ? 'is-invalid hide_select'
                          : 'hide_select'
                      "
                      placeholder="Enter Delivery "
                      v-if="!request_quotation.isHideShowPk"
                      :disabled="readonly"
                      :options="{
                        value: 'id',
                        label: 'text',
                        data: locations,
                        fields: [
                          {
                            field: 'abbreviations',
                            label: 'Abbreviations',
                          },
                          {
                            field: 'name',
                            label: 'Location',
                          },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <b-form-input
                      v-if="request_quotation.isHideShowPk"
                      :disabled="readonly"
                      v-model="request_quotation.other_delivery_location"
                      placeholder="Enter pick up"
                    />
                    <b-form-checkbox
                      :disabled="readonly"
                      v-on:change="hideShowsPk"
                      v-model="request_quotation.isHideShowPk"
                      class="check_input"
                      >Other
                    </b-form-checkbox>
                  </div>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- <b-col
              cols="12"
              lg="4"
              v-if="step == 'booking' || step == 'view-quotation-booking'"
            >
              <b-form-group>
                <label>Shipping Type </label>
                <Select2
                  :disabled="readonly"
                  placeholder="Shipping Type"
                  v-model="request_quotation.shippingType"
                  :options="
                    request_quotation.service_type == 5
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : request_quotation.service_type == 6
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : transport_types.filter((i) => [1, 2].includes(i.id))
                  "
                />
              </b-form-group>
            </b-col> -->
          </b-row>

          <b-row v-if="step == 'booking' || step == 'view-quotation-booking'">
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Pick up date</label>

                <section>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.pick_up_date"
                    type="datetime"
                    class="w-full"
                    :disabled="readonly"
                    value-type="format"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>
                </section>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Delivery Date</label>

                <section>
                  <date-picker
                    ref="datePicker"
                    v-model="request_quotation.delivery_date"
                    :disabled-date="disabledRangeDelivery"
                    type="datetime"
                    class="w-full"
                    value-type="format"
                    :disabled="readonly"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}
                      </button>
                    </template>
                  </date-picker>
                </section>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="PIC pick up"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>PIC pick up</label>
                  <b-form-input
                    placeholder="PIC pick up"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.PICPickUp"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="PIC Delivery"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>PIC Delivery</label>
                  <b-form-input
                    placeholder="PIC Delivery"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.PICDelivery"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              v-if="step != 'booking' && step != 'view-quotation-booking'"
              cols="12"
              lg="6"
              class="pt-1"
            >
              <h4>Freight Informations</h4>
            </b-col>
            <b-col
              cols="12"
              :lg="
                step != 'booking' && step != 'view-quotation-booking' ? 6 : 12
              "
              class="pt-1"
            >
              <h4>Cargo Information</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              lg="6"
              v-if="step != 'booking' && step != 'view-quotation-booking'"
            >
              <b-form-group>
                <label>Volume (Monthly)</label>
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.volume"
                  placeholder="Volume (Monthly)"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              :lg="
                step == 'booking' || step == 'view-quotation-booking' ? 4 : 6
              "
            >
              <validation-provider
                name="Commodity"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Commodity<font class="red">*</font></label>
                  <Select2
                    :disabled="readonly"
                    placeholder="Commodity"
                    v-model="request_quotation.goods_type"
                    :options="goods_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              lg="4"
              v-if="step == 'booking' || step == 'view-quotation-booking'"
            >
              <validation-provider
                name="Commodity description"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Commodity description</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.mo_ta"
                    placeholder="Commodity description"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="step == 'booking' || step == 'view-quotation-booking'"
              cols="12"
              lg="4"
            >
              <validation-provider
                name="Gross Weight (kgs)"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Total Gross Weight (kg)</label>

                  <cleave
                    :state="errors.length > 0 ? false : null"
                    :options="$Utils.CONSTANTS.cleaveNumeral"
                    :disabled="readonly"
                    v-model="request_quotation.trong_luong"
                    class="form-control"
                    placeholder="Gross Weight (kgs)"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row v-if="step == 'booking' || step == 'view-quotation-booking'">
            <b-col cols="12" lg="4">
              <b-form-group>
                <label>Measurement (cbm)</label>
                <cleave
                  :options="$Utils.CONSTANTS.cleaveNumeral"
                  :disabled="readonly"
                  v-model="request_quotation.so_khoi"
                  class="form-control"
                  placeholder="Measurement (kgs)"
                />
                <!-- <b-form-input
                  type="number"
                  :disabled="readonly"
                  v-model="request_quotation.so_khoi"
                  placeholder="Measurement (kgs)"
                /> -->
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Package Type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Package Type </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Package type"
                    v-model="request_quotation.package_type"
                    :options="cont_types.filter((i) => i.group === 'packaging')"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Package Number"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Package Number</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.packageNumber"
                    placeholder="Package Number"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="4" class="pt-1">
              <h4>Other service</h4>
            </b-col>
            <b-col cols="3" class="pt-1">
              <b-form-checkbox
                :disabled="readonly"
                v-model="request_quotation.has_customs"
                >Customs services
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row v-if="request_quotation.has_customs">
            <b-col cols="12" lg="12" class="pt-1">
              <h4>Customs declaration information</h4>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Customs type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Customs type </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Customs type"
                    v-model="request_quotation.customs_type"
                    :options="customs_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Business type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Business type</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Business type"
                    v-model="request_quotation.business_type"
                    :options="business_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Place of Custom declaration"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Place of Custom declaration </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.customs_addr"
                    placeholder="Place of Custom declaration"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>HS Code</label>
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.hs_code"
                  placeholder="HS Code"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Notes</label>
                <b-form-textarea
                  rows="5"
                  :disabled="readonly"
                  v-model="request_quotation.notes"
                  placeholder="Notes"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <!-- multi file upload starts -->
        </div>

        <!--customs-->
        <div v-if="request_quotation.service_type == 4">
          <b-row>
            <b-col cols="12" lg="12" class="pt-1">
              <h4>Customs declaration information</h4>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Customs type"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Customs type<font class="red">*</font></label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Customs type"
                    v-model="request_quotation.customs_type"
                    :options="customs_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Business type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Business type</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Business type"
                    v-model="request_quotation.business_type"
                    :options="business_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Place of Custom declaration</label>
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.customs_addr"
                  placeholder="Place of Custom declaration"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>HS Code</label>
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.hs_code"
                  placeholder="HS Code"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              v-if="step != 'booking' && step != 'view-quotation-booking'"
              cols="12"
              lg="6"
              class="pt-1"
            >
              <h4>Freight Informations</h4>
            </b-col>
            <b-col
              cols="12"
              :lg="
                step != 'booking' && step != 'view-quotation-booking' ? 6 : 12
              "
              class="pt-1"
            >
              <h4>Cargo Information</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              lg="6"
              v-if="step != 'booking' && step != 'view-quotation-booking'"
            >
              <b-form-group>
                <label>Volume (Monthly)</label>
                <b-form-input
                  :disabled="readonly"
                  v-model="request_quotation.volume"
                  placeholder="Volume (Monthly)"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              :lg="
                (step == 'booking' || step == 'view-quotation-booking') &&
                request_quotation.customs_other_service_type == 'VAN'
                  ? 4
                  : step == 'booking' || step == 'view-quotation-booking'
                  ? 6
                  : 3
              "
            >
              <validation-provider
                name="Commodity"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Commodity<font class="red">*</font></label>
                  <Select2
                    :disabled="readonly"
                    placeholder="Commodity"
                    v-model="request_quotation.goods_type"
                    :options="goods_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              :lg="
                (step == 'booking' || step == 'view-quotation-booking') &&
                request_quotation.customs_other_service_type == 'VAN'
                  ? 4
                  : step == 'booking' || step == 'view-quotation-booking'
                  ? 6
                  : 3
              "
            >
              <validation-provider
                name="Commodity description"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Commodity description</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.mo_ta"
                    placeholder="Commodity description"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="
                (step == 'booking' || step == 'view-quotation-booking') &&
                request_quotation.customs_other_service_type == 'VAN'
              "
              cols="12"
              lg="4"
            >
              <validation-provider
                name="Gross Weight (kgs)"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Total Gross Weight (kg)</label>

                  <cleave
                    :state="errors.length > 0 ? false : null"
                    :options="$Utils.CONSTANTS.cleaveNumeral"
                    :disabled="readonly"
                    v-model="request_quotation.trong_luong"
                    class="form-control"
                    placeholder="Gross Weight (kgs)"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row
            v-if="
              (step == 'booking' || step == 'view-quotation-booking') &&
              request_quotation.customs_other_service_type == 'VAN'
            "
          >
            <b-col cols="12" lg="4">
              <b-form-group>
                <label>Measurement (cbm)</label>
                <cleave
                  :options="$Utils.CONSTANTS.cleaveNumeral"
                  :disabled="readonly"
                  v-model="request_quotation.so_khoi"
                  class="form-control"
                  placeholder="Measurement (kgs)"
                />
                <!-- <b-form-input
                  type="number"
                  :disabled="readonly"
                  v-model="request_quotation.so_khoi"
                  placeholder="Measurement (kgs)"
                /> -->
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Package Type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Package Type </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Package type"
                    v-model="request_quotation.package_type"
                    :options="cont_types.filter((i) => i.group === 'packaging')"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Package Number"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Package Number</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.packageNumber"
                    placeholder="Package Number"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row
            v-if="
              (step == 'booking' || step == 'view-quotation-booking') &&
              request_quotation.customs_other_service_type == 'CONTAINER'
            "
          >
            <b-col cols="12" class="pt-1">
              <h4>Freight Informations</h4>
            </b-col>
            <b-col cols="12">
              <validation-provider
                name="Carrier"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Carrier</label>
                  <Select4
                    v-model="request_quotation.shipping_line"
                    :class="[
                      errors.length > 0 ? 'is-invalid' : null,
                      readonly == true ? 'remove' : '',
                    ]"
                    placeholder="Carrier"
                    :disabled="readonly"
                    :options="{
                      value: 'id',
                      label: 'text',
                      data: shipping_lines,
                      fields: [
                        {
                          field: 'code',
                          label: 'Code',
                        },
                        {
                          field: 'name',
                          label: 'Shipping Line',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Commodity"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Commodity<font class="red">*</font></label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Commodity"
                    v-model="request_quotation.goods_type"
                    :options="goods_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Commodity description"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Commodity description<font class="red">*</font></label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.mo_ta"
                    placeholder="Commodity description"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <b-form-group>
                <label>Volume (Monthly)</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Volume (Monthly)"
                  v-model="request_quotation.volume"
                  :options="volumes"
                />
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col cols="12" lg="4" class="pt-1">
              <h4 class="float-left">Other service</h4>
              <b-button
                @click="request_quotation.customs_other_service_type = null"
                variant="flat-danger"
                :class="{ 'd-none': readonly }"
                class="p-0 m-0 ml-1 float-left"
              >
                <feather-icon size="1.2x" icon="TrashIcon" />
              </b-button>
            </b-col>
            <b-col cols="12" lg="4" class="pt-1">
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  v-model="request_quotation.customs_other_service_type"
                  :options="[
                    {
                      text: 'Container Trucking',
                      value: 'CONTAINER',
                    },
                    { text: 'Van Trucking', value: 'VAN' },
                  ]"
                  :disabled="readonly"
                  :aria-describedby="ariaDescribedby"
                  name="radio-options"
                >
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <div v-if="request_quotation.customs_other_service_type == 'VAN'">
            <b-row>
              <b-col cols="12">
                <h4>Shipment Informations</h4>
              </b-col>
            </b-row>
            <b-row
              v-if="
                (step == 'booking' || step == 'view-quotation-booking') &&
                request_quotation.customs_other_service_type == 'VAN'
              "
            >
              <b-col cols="12" lg="6">
                <b-form-group>
                  <label>Booking/HBL/INV</label>
                  <b-form-input
                    :disabled="readonly"
                    placeholder="Booking/HBL/INV"
                    v-model="request_quotation.HBL"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <b-form-group>
                  <label>Shipping Type</label>
                  <Select2
                    :disabled="readonly"
                    placeholder="Shipping Type"
                    v-model="request_quotation.shippingType"
                    :options="
                      request_quotation.service_type == 5
                        ? transport_types.filter((i) =>
                            [1, 2, 3, 4].includes(i.id)
                          )
                        : request_quotation.service_type == 6
                        ? transport_types.filter((i) =>
                            [1, 2, 3, 4].includes(i.id)
                          )
                        : transport_types.filter((i) => [1, 2].includes(i.id))
                    "
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Truck Type"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Truck Type</label>
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="Truck Type"
                      v-model="request_quotation.truck_type"
                      :options="
                        cont_types.filter((i) => i.group === 'van truck')
                      "
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Quantity"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Quantity</label>
                    <b-form-input
                      placeholder="Quantity"
                      type="number"
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      v-model="request_quotation.so_luong"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row
              v-if="
                step == 'created-quotation' ||
                step == 'view-created-quotation' ||
                (step == 'view-quotation-booking' &&
                  (request_quotation.pickup_region != null ||
                    request_quotation.other_pickup_region) &&
                  step != 'booking')
              "
            >
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Pick up"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Pick up<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select2
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="hide_select"
                        :disabled="readonly"
                        placeholder="Pick up"
                        v-if="!request_quotation.isHideShows"
                        v-model="request_quotation.pickup_region"
                        :options="regions"
                      />
                      <b-form-input
                        v-if="request_quotation.isHideShows"
                        :disabled="readonly"
                        v-model="request_quotation.other_pickup_region"
                        placeholder="Enter pick up "
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsi"
                        v-model="request_quotation.isHideShows"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Delivery"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Delivery<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select2
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="hide_select"
                        :disabled="readonly"
                        v-if="!request_quotation.isHideShowPk"
                        placeholder="Delivery"
                        v-model="request_quotation.delivery_region"
                        :options="regions"
                      />
                      <b-form-input
                        :disabled="readonly"
                        v-if="request_quotation.isHideShowPk"
                        v-model="request_quotation.other_delivery_region"
                        placeholder="Enter pick up"
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsPk"
                        v-model="request_quotation.isHideShowPk"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row v-else>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Pick up"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Pick up<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select4
                        v-model="request_quotation.pickup_location"
                        :key="countRq"
                        :class="
                          errors.length > 0
                            ? 'is-invalid hide_select'
                            : 'hide_select'
                        "
                        placeholder="Enter Pick up "
                        v-if="!request_quotation.isHideShows"
                        :disabled="readonly"
                        :options="{
                          value: 'id',
                          label: 'text',
                          data: locations,
                          fields: [
                            {
                              field: 'abbreviations',
                              label: 'Abbreviations',
                            },
                            {
                              field: 'name',
                              label: 'Location',
                            },
                            {
                              field: 'address',
                              label: 'Address',
                            },
                          ],
                        }"
                      />
                      <b-form-input
                        v-if="request_quotation.isHideShows"
                        :disabled="readonly"
                        v-model="request_quotation.other_pickup_location"
                        placeholder="Enter pick up "
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsi"
                        v-model="request_quotation.isHideShows"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Delivery"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Delivery<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select4
                        v-model="request_quotation.delivery_location"
                        :key="countRq"
                        :class="
                          errors.length > 0
                            ? 'is-invalid hide_select'
                            : 'hide_select'
                        "
                        placeholder="Enter Delivery "
                        v-if="!request_quotation.isHideShowPk"
                        :disabled="readonly"
                        :options="{
                          value: 'id',
                          label: 'text',
                          data: locations,
                          fields: [
                            {
                              field: 'abbreviations',
                              label: 'Abbreviations',
                            },
                            {
                              field: 'name',
                              label: 'Location',
                            },
                            {
                              field: 'address',
                              label: 'Address',
                            },
                          ],
                        }"
                      />
                      <b-form-input
                        v-if="request_quotation.isHideShowPk"
                        :disabled="readonly"
                        v-model="request_quotation.other_delivery_location"
                        placeholder="Enter pick up"
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsPk"
                        v-model="request_quotation.isHideShowPk"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row> </b-row>
            <b-row
              v-if="
                request_quotation.customs_other_service_type == 'VAN' &&
                (step == 'booking' || step == 'view-quotation-booking')
              "
            >
              <b-col cols="12" lg="6">
                <b-form-group>
                  <label>Pick up date</label>

                  <section>
                    <date-picker
                      ref="datePicker"
                      v-model="request_quotation.pick_up_date"
                      type="datetime"
                      class="w-full"
                      :disabled="readonly"
                      value-type="format"
                      title-format="DD/MM/YY"
                      time-title-format="DD/MM/YY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD/MM/YY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}
                        </button>
                      </template>
                    </date-picker>
                  </section>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <b-form-group>
                  <label>Delivery Date</label>

                  <section>
                    <date-picker
                      ref="datePicker"
                      v-model="request_quotation.delivery_date"
                      :disabled-date="disabledRangeDelivery"
                      type="datetime"
                      class="w-full"
                      value-type="format"
                      :disabled="readonly"
                      title-format="DD/MM/YY"
                      time-title-format="DD/MM/YY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD/MM/YY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}
                        </button>
                      </template>
                    </date-picker>
                  </section>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="PIC pick up"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>PIC pick up</label>
                    <b-form-input
                      placeholder="PIC pick up"
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      v-model="request_quotation.PICPickUp"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="PIC Delivery"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>PIC Delivery</label>
                    <b-form-input
                      placeholder="PIC Delivery"
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      v-model="request_quotation.PICDelivery"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </div>
          <div
            v-if="request_quotation.customs_other_service_type == 'CONTAINER'"
          >
            <b-row>
              <b-col cols="12">
                <h4>Shipment Informations</h4>
              </b-col>
            </b-row>
            <b-row
              v-if="
                (step == 'booking' || step == 'view-quotation-booking') &&
                request_quotation.customs_other_service_type == 'CONTAINER'
              "
            >
              <b-col cols="12" lg="6">
                <b-form-group>
                  <label>Booking/HBL/INV</label>
                  <b-form-input
                    :disabled="readonly"
                    placeholder="Booking/HBL/INV"
                    v-model="request_quotation.HBL"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <b-form-group>
                  <label>Shipping Type</label>
                  <Select2
                    :disabled="readonly"
                    placeholder="Shipping Type"
                    v-model="request_quotation.shippingType"
                    :options="
                      request_quotation.service_type == 5
                        ? transport_types.filter((i) =>
                            [1, 2, 3, 4].includes(i.id)
                          )
                        : request_quotation.service_type == 6
                        ? transport_types.filter((i) =>
                            [1, 2, 3, 4].includes(i.id)
                          )
                        : transport_types.filter((i) => [1, 2].includes(i.id))
                    "
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Container Type"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Container Type</label>
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="Container Type"
                      v-model="request_quotation.cont_type"
                      :options="
                        cont_types.filter((i) => i.group === 'Container truck')
                      "
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" lg="6">
                <validation-provider
                  name="Quantity"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Quantity</label>
                    <b-form-input
                      placeholder="Quantity"
                      type="number"
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      v-model="request_quotation.so_luong"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row v-if="step == 'booking'">
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Container No."
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Container No.</label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      v-model="request_quotation.container_no"
                      placeholder="Quantity"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Seal No."
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Seal No.</label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      v-model="request_quotation.seal"
                      placeholder="Quantity"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                lg="4"
                v-if="
                  step == 'created-quotation' ||
                  step == 'view-created-quotation' ||
                  (step == 'view-quotation-booking' &&
                    (request_quotation.pickup_region != null ||
                      request_quotation.other_pickup_region) &&
                    step != 'booking')
                "
              >
                <validation-provider
                  name="Pick up"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Pick up<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select2
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="hide_select"
                        :disabled="readonly"
                        v-if="!request_quotation.isHideShows"
                        placeholder="Pick up"
                        v-model="request_quotation.pickup_region"
                        :options="regions"
                      />
                      <b-form-input
                        :disabled="readonly"
                        v-if="request_quotation.isHideShows"
                        v-model="request_quotation.other_pickup_region"
                        placeholder="Enter pick up "
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsi"
                        v-model="request_quotation.isHideShows"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                lg="4"
                v-if="
                  step == 'created-quotation' ||
                  step == 'view-created-quotation' ||
                  (step == 'view-quotation-booking' &&
                    (request_quotation.delivery_region != null ||
                      request_quotation.other_delivery_region) &&
                    step != 'booking')
                "
              >
                <validation-provider
                  name="Delivery"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Delivery<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select2
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="hide_select"
                        :disabled="readonly"
                        v-if="!request_quotation.isHideShowPk"
                        placeholder="Delivery"
                        v-model="request_quotation.delivery_region"
                        :options="regions"
                      />
                      <b-form-input
                        v-if="request_quotation.isHideShowPk"
                        :disabled="readonly"
                        v-model="request_quotation.other_delivery_region"
                        placeholder="Enter pick up"
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsPk"
                        v-model="request_quotation.isHideShowPk"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col
                cols="12"
                lg="4"
                v-if="
                  (step != 'created-quotation' &&
                    step != 'view-created-quotation' &&
                    step == 'view-quotation-booking' &&
                    (request_quotation.pickup_location != null ||
                      request_quotation.other_pickup_location != null)) ||
                  step == 'booking'
                "
              >
                <validation-provider
                  name="Pick up"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Pick up<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select4
                        v-model="request_quotation.pickup_location"
                        :key="countRq"
                        :class="
                          errors.length > 0
                            ? 'is-invalid hide_select'
                            : 'hide_select'
                        "
                        placeholder="Enter Pick up "
                        v-if="!request_quotation.isHideShows"
                        :disabled="readonly"
                        :options="{
                          value: 'id',
                          label: 'text',
                          data: locations,
                          fields: [
                            {
                              field: 'abbreviations',
                              label: 'Abbreviations',
                            },
                            {
                              field: 'name',
                              label: 'Location',
                            },
                            {
                              field: 'address',
                              label: 'Address',
                            },
                          ],
                        }"
                      />
                      <b-form-input
                        :disabled="readonly"
                        v-if="request_quotation.isHideShows"
                        v-model="request_quotation.other_pickup_location"
                        placeholder="Enter pick up "
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsi"
                        v-model="request_quotation.isHideShows"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                lg="4"
                v-if="
                  (step != 'created-quotation' &&
                    step != 'view-created-quotation' &&
                    step == 'view-quotation-booking' &&
                    (request_quotation.delivery_location != null ||
                      request_quotation.other_delivery_location != null)) ||
                  step == 'booking'
                "
              >
                <validation-provider
                  name="Delivery"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Delivery<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select4
                        v-model="request_quotation.delivery_location"
                        :key="countRq"
                        :class="
                          errors.length > 0
                            ? 'is-invalid hide_select'
                            : 'hide_select'
                        "
                        placeholder="Enter Delivery "
                        v-if="!request_quotation.isHideShowPk"
                        :disabled="readonly"
                        :options="{
                          value: 'id',
                          label: 'text',
                          data: locations,
                          fields: [
                            {
                              field: 'abbreviations',
                              label: 'Abbreviations',
                            },
                            {
                              field: 'name',
                              label: 'Location',
                            },
                            {
                              field: 'address',
                              label: 'Address',
                            },
                          ],
                        }"
                      />
                      <b-form-input
                        :disabled="readonly"
                        v-if="request_quotation.isHideShowPk"
                        v-model="request_quotation.other_delivery_location"
                        placeholder="Enter pick up"
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsPk"
                        v-model="request_quotation.isHideShowPk"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col
                cols="12"
                lg="4"
                v-if="
                  (step != 'created-quotation' &&
                    step != 'view-created-quotation' &&
                    step == 'view-quotation-booking' &&
                    request_quotation.deport_location != null) ||
                  step == 'booking'
                "
              >
                <b-form-group>
                  <label>Empty depot<font class="red">*</font></label>

                  <Select4
                    v-model="request_quotation.deport_location"
                    :key="countRq"
                    placeholder="Empty depot"
                    :disabled="readonly"
                    :options="{
                      value: 'id',
                      label: 'text',
                      data: locations,
                      fields: [
                        {
                          field: 'abbreviations',
                          label: 'Abbreviations',
                        },
                        {
                          field: 'name',
                          label: 'Location',
                        },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4" v-else>
                <b-form-group>
                  <label>Empty depot<font class="red">*</font></label>
                  <Select2
                    :disabled="readonly"
                    placeholder="Empty depot"
                    v-model="request_quotation.deport"
                    :options="regions"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row
              v-if="
                request_quotation.customs_other_service_type == 'CONTAINER' &&
                (step == 'booking' || step == 'view-quotation-booking')
              "
            >
              <b-col cols="12" lg="4">
                <b-form-group>
                  <label>Pick up date</label>

                  <section>
                    <date-picker
                      ref="datePicker"
                      v-model="request_quotation.pick_up_date"
                      type="datetime"
                      class="w-full"
                      :disabled="readonly"
                      value-type="format"
                      title-format="DD/MM/YY"
                      time-title-format="DD/MM/YY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD/MM/YY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}
                        </button>
                      </template>
                    </date-picker>
                  </section>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group>
                  <label>Delivery Date</label>

                  <section>
                    <date-picker
                      ref="datePicker"
                      v-model="request_quotation.delivery_date"
                      :disabled-date="disabledRangeDelivery"
                      type="datetime"
                      class="w-full"
                      value-type="format"
                      :disabled="readonly"
                      title-format="DD/MM/YY"
                      time-title-format="DD/MM/YY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD/MM/YY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}
                        </button>
                      </template>
                    </date-picker>
                  </section>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group>
                  <label>Cut off Date</label>

                  <section>
                    <date-picker
                      ref="datePicker"
                      v-model="request_quotation.cutOffDate"
                      type="datetime"
                      class="w-full"
                      :disabled="readonly"
                      value-type="format"
                      title-format="DD/MM/YY"
                      time-title-format="DD/MM/YY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD/MM/YY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}
                        </button>
                      </template>
                    </date-picker>
                  </section>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="PIC pick up"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>PIC pick up</label>
                    <b-form-input
                      placeholder="PIC pick up"
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      v-model="request_quotation.PICPickUp"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="PIC Delivery"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>PIC Delivery</label>
                    <b-form-input
                      placeholder="PIC Delivery"
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      v-model="request_quotation.PICDelivery"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Notes</label>
                <b-form-textarea
                  rows="5"
                  :disabled="readonly"
                  v-model="request_quotation.notes"
                  placeholder="Notes"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            v-if="
              request_quotation.customs_other_service_type == 'CONTAINER' &&
              (step == 'booking' || step == 'view-quotation-booking')
            "
          >
            <b-col cols="12">
              <b-form-group>
                <label>Billing information</label>
                <b-form-textarea
                  rows="5"
                  :disabled="readonly"
                  v-model="request_quotation.billingInformation"
                  placeholder="Billing information"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <b-row v-if="!readonly">
          <b-col cols="12">
            <AttachFile ref="attachFile" />
          </b-col>
        </b-row>
        <b-row class="pb-1 pt-2">
          <b-col cols="12">
            <a
              v-if="
                !readonly &&
                step != 'booking' &&
                isCustomer &&
                step != 'copy-booking' &&
                step != 'edit_quotation'
              "
              @click="sendRequestQuotation"
              class="btn round btn-success pl-4 pr-4 mr-1"
            >
              <feather-icon icon="SendIcon" /> Send
            </a>
            <!-- save edit RequestQuotation  -->
            <a
              v-if="
                !readonly &&
                view_RequestQuotation != null &&
                step != 'booking' &&
                step != 'created-quotation' &&
                step != 'copy-booking'
              "
              @click="sendRequestQuotation"
              class="btn round btn-success pl-4 pr-4 mr-1"
            >
              <feather-icon icon="SendIcon" /> Save
            </a>
            <a
              v-if="
                (!readonly &&
                  step == 'booking' &&
                  view_RequestQuotation == null &&
                  isCustomer) ||
                (readonlyService &&
                  view_RequestQuotation != null &&
                  isCustomer &&
                  step != 'created-quotation') ||
                (step == 'copy-booking' &&
                  view_RequestQuotation != null &&
                  isCustomer)
              "
              @click="sendRequestQuotation"
              class="btn round btn-success pl-4 pr-4 mr-1"
            >
              <feather-icon icon="SendIcon" /> New Booking
            </a>
            <a
              v-if="
                !readonly &&
                step == 'booking' &&
                view_RequestQuotation != null &&
                !readonlyService &&
                isCustomer
              "
              @click="sendRequestQuotation"
              class="btn round btn-success pl-4 pr-4 mr-1"
            >
              <feather-icon icon="SendIcon" /> Edit Booking
            </a>
          </b-col>
        </b-row>
      </validation-observer>
    </div>

    <b-col
      cols="12"
      class="pb-3"
      v-if="
        ![1, 2, 3, 4, 21, 5].includes(request_quotation.status_id) &&
        request_quotation.status_id &&
        getTotalAll() > 0
      "
    >
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col class="d-flex justify-content-end">
              <!-- v-if="getTotal(c.id) > 0" -->
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="outline-success"
                @click="$emit('clickActiveTab')"
                class="d-flex justify-content-end cursor-pointer align-self-center align-items-center text-center"
              >
                <div>
                  <div v-for="c in currencies" :key="c.id">
                    <span v-if="getTotal(c.id) > 0" class="d-flex">
                      <h3 class="text-warning mb-0 mr-2">Grand Total:</h3>
                      <h3 class="text-primary mb-0">
                        {{
                          c.id == "VND"
                            ? $Utils.formatMooney(
                                getTotalGrandTotal(c.id),
                                "vi-VN"
                              )
                            : $Utils.formatMooney(
                                getTotalGrandTotal(c.id),
                                "en-US"
                              )
                        }}
                        {{ c.id }}
                      </h3>
                    </span>
                  </div>
                </div>
                <feather-icon
                  width="24px"
                  height="24px"
                  class="text-primary ml-2"
                  icon="ArrowRightIcon"
                />
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    <SelectSchedule
      v-if="modalSchedule"
      v-model="modalSchedule"
      @select="onSelectSchedule"
      :isCustomer="isCustomer"
      :options="{
        service:
          $Utils.CONSTANTS.SERVICE_TYPE_ID[request_quotation.service_type] ||
          '',
        pol_name: this.request_quotation.pol_name,
        pod_name: this.request_quotation.pod_name,
        pol: this.request_quotation.pol_port,
        pod: this.request_quotation.pod_port,
        cargo_ready: this.request_quotation.cargo_ready,
      }"
    />
  </div>
</template>
<style>
.remove .select2-selection--single::before {
  background-image: none !important;
}

.is-invalid .select2-selection--single {
  border: 1px solid #ea5455;
}

.is-invalid .select2-selection--single::before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ea5455' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ea5455' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
}

.red {
  color: red;
}

.vue-dropzone > .dz-preview .dz-details {
  background-color: #2b938c;
  border-radius: 15px;
}

.hide_select {
  display: block;
}

.hide_input {
  display: none;
}

.hide_show .hide_input {
  display: block;
}

.hide_input {
  width: 80%;
}

.hide_show .hide_select {
  display: none;
}

.hide_select {
  width: 100%;
}

.check_input {
  width: 10%;
  margin-left: 30px;
}

#__BVID__13587__BV_tab_container_ .check_input {
  display: none;
}
</style>
<script>
import {
  BButton,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";
import Select2 from "v-select2-component";
import useJwt from "@/auth/jwt/useJwt";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import AttachFile from "../quotation/from-booking/components/AttachFile.vue";
import { mapState, mapActions } from "vuex";
import Ripple from "vue-ripple-directive";

import { $ctx } from "@themeConfig";
import moment from "moment";
import { checkPort } from "@/utils/checkPort";
import ContainerTruckSale from "../V2/NewContainerTruckSale/index.vue";
import NewVanTruckSale from "../V2/NewVanTruckSale/index.vue";
import NewBookingSale from "../V2/NewBookingSale/index.vue";
export default {
  directives: {
    Ripple,
  },
  props: {
    cards: {},
    className: { default: "booking-online" },
    readonly: { default: false, type: Boolean },
    view_RequestQuotation: { default: null },
    booking: { default: null },
    readonlyService: { default: false },
    step: { default: null },
    isCustomer: { default: true },
    chooseServiceType: { default: null },

    createdRequestQuotation: { default: null },
    isCopy : {default : null }
  },
  components: {
    ContainerTruckSale,
    NewVanTruckSale,
    BButton,
    ValidationProvider,
    ValidationObserver,
    NewBookingSale,
    BCardText,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    Select2,
    vueDropzone: vue2Dropzone,
    FeatherIcon,
    AttachFile,
  },
  data() {
    return {
      checkPort,
      modalSchedule: false,
      buttonKey: 1,
      moment,
      showTimePanel: false,
      showTimeRangePanel: false,
      isHideShow: false,
      isHideShowPk: false,
      vm: this,
      userData: JSON.parse(localStorage.getItem("userData")),

      locationsByUser: [],

      request_quotation: {
        showAddMore: [
          {
            id: 1,
            hasDelete: false,
            showAddMoreLine: [
              {
                id: 2,
                hasDelete: false,
                gross_weight: null,
                volume: null,
                packages: null,
                dimension: {
                  lenght: null,
                  width: null,
                  height: null,
                },
              },
            ],
            package_type: null,
            total_packages: 0,
            gross_weight_total: 0,
            volume_total: 0,
          },
        ],

        valueVan: [
          {
            id: 1,
            hasDelete: false,
            truck_type: null,
            quantity: null,
            commodity_type: null,

            VanLine: [
              {
                id: 2,
                hasDelete: false,
                commodity: null,
                total_gross_weight: null,
                total_package: null,
                total_volume: null,
                dimension: {
                  lenght: null,
                  width: null,
                  height: null,
                },
              },
            ],
          },
        ],

        valueContainer: [
          {
            id: 1,
            hasDelete: false,
            commodity_type: null,
            commodity: null,
            container_type: null,
                quantity: null,
                total_gross_weight: null,
         
          },
        ],

        paymentTerms: null,
        pickUpContact: {
          name: null,
          phone: null,
        },
        deliveryContact: {
          name: null,
          phone: null,
        },
        isPickUpInput: null,
        eta: null,
        quotation: null,
        etd: null,
        customs_other_service_type: null,
        has_container_trucking: null,
        isHideShows: false,
        isHideShowPks: false,
        other_pickup_location: null,
        other_delivery_location: null,
        pickup_location: null,
        delivery_location: null,
        other_pickup_region: null,
        other_delivery_region: null,
        pickup_region: null,
        delivery_region: null,
        company_id: null,
        customer_id: null,
        service_type: null,
        pod_port: null,
        pol_port: null,
        incoterms: null,
        cont_type: null,
        goods_type: null,
        package_type: null,
        transport_type: null,
        deport: null,
        business_type: null,
        so_luong: null,
        trong_luong: null,
        mo_ta: null,
        volume: null,
        from_date: null,
        to_date: null,
        other_service: null,
        notes: null,
        so_khoi: null,
        so_kien: null,
        shipping_line: null,
        place_of_stuffing: null,
        totalChargeWeight: null,
        size_: {
          length_: null,
          width_: null,
          height_: null,
        },
        cargo_ready: moment().format("DD/MM/YY HH:mm"),
        customs_addr: null,
        hs_code: null,
        //Container Truck
        pickUpDateTime: null,
        pickUpDate: null,
        pickUpTime: null,
        deliveryDateTime: null,
        deliveryDate: null,
        deliveryTime: null,
        cargo_booking: null,
        carrier: null,
        cargo_closing_dateTime: null,
        cargo_closing_date: null,
        cargo_closing_time: null,
        cargo_details_commodity_truck: [
          {
            id: 1,
            hasDelete: false,
            commodity_type: null,
            commodity: null,
          },
        ],
        cargo_details_container_truck: [
          {
            id: 2,
            hasDelete: false,
            container_type: null,
            quantity: null,
            total_gross_weight: null,
          },
        ],
        additional_custom: false,
        additional_custom_input: null,
        has_other_custom: false,
        place_of_custom: null,
        HS_code_truck: null,
        customs_type: null,
        notes_truck: null,
        door_contact_pick_up: {
          name: "",
          phone: "",
          email: "",
        },
        door_contact_delivery: {
          name: "",
          phone: "",
          email: "",
        },
        inland_contact_pick_up: {
          name: "",
          phone: "",
          email: "",
        },
        inland_contact_delivery: {
          name: "",
          phone: "",
          email: "",
        },
      },
      customer_list_options: null,

      volumes: [
        { id: 1, text: "1-10" },
        { id: 2, text: "10-30" },
        { id: 3, text: "30-50" },
        { id: 4, text: "50-100" },
        { id: 5, text: ">100" },
      ],
      currencies: [
        { id: "VND", text: "VNĐ" },
        { id: "USD", text: "USD" },
      ],
      dropzoneOptions: {
        url: $ctx.API_URL + this.$Utils.CONSTANTS.TYPE_UPLOAD.URL,
        addRemoveLinks: !this.readonly,
        acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
        maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
        maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
        headers: { apiKey: localStorage.getItem("accessToken") },
        clickable: !this.readonly,
      },
      customer_list: null,
      useName: null,
      costs: [],

      countRq: 0,
    };
  },

  watch: {
    chooseServiceType(n) {
      // console.log(n);
    },
    "request_quotation.customs_other_service_type": function (n, o) {
      this.request_quotation.has_van_trucking = null;
      this.request_quotation.has_container_trucking = null;
      if (n == "CONTAINER") {
        this.request_quotation.has_container_trucking = true;
      }
      if (n == "VAN") {
        this.request_quotation.has_van_trucking = true;
      }
    },
    "request_quotation.company_id": function (n, o) {
      if (
        !this.readonly &&
        (this.userData.userType ==
          this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
          this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin)
      ) {
        useJwt
          .get("wr1?objectType=CustomerListCompany", {
            params: { search: n },
          })
          .then((response) => {
            this.customer_list_options = this.formatOption(
              response.data.result
            );
            if (this.request_quotation.customer_id == null) {
              this.request_quotation.customer_id =
                this.customer_list_options.filter(
                  (e) => e.user_type == 2
                )[0]?.code;
            }
          });
      }
    },
    "request_quotation.customer_id"(n) {
      this.useName = n;
    },
    useName(n) {
      if (n) {
        useJwt
          .get("getLocationsByUserId", {
            params: { page: 1, pageSize: 2000, userId: n },
          })
          .then((response) => {
            this.locationsByUser = response.data.result.map((e) => {
              const result = {};
              result.text =
                e.abbreviations + " - " + e.detail_address || e.location;
              result.id = e.location_id;
              result.name = e.location;
              result.abbreviations = e.abbreviations;

              result.address = e.detail_address || e.location;

              return result;
            });
            this.countRq++;
          });
      }
    },

    ...["request_quotation.so_khoi", "request_quotation.trong_luong"].reduce(
      (watchers, key) => ({
        ...watchers,
        [key](newVal, oldVal) {
          var vm = this;

          if (vm.request_quotation.service_type == 1) {
            vm.request_quotation.trong_luong >
            vm.request_quotation.so_khoi * 167
              ? (vm.request_quotation.totalChargeWeight =
                  vm.request_quotation.trong_luong)
              : (vm.request_quotation.totalChargeWeight =
                  vm.request_quotation.so_khoi * 167);
          }
        },
      }),
      {}
    ),
  },
  computed: {
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "handed_types",
      'quotations'
    ]),
    shippingTypeOptions() {
      return [...this.locations, ...this.regions];
    },
    company_list() {
      return this.companyItems;
    },
    locations() {
      this.countRq++;

      return [...this.locationsByUser, ...this.allLocationsPublic];
    },
    locationsNoService() {
      return [...this.locationsByUser, ...this.allLocationsPublicNoServices];
    },
    allLocationsPublicNoServices() {
      return this.$store.state.masterData.locations.filter((item) =>
        [1, 2, 3].includes(item.location_type_id)
      );
    },
    allLocationsPublic() {
      return this.$store.state.masterData.locations.filter((item) =>
        [1, 2, 3, 5].includes(item.location_type_id)
      );
    },
  },
  created() {
    if (this.isCustomer) {
      this.useName = this.userData.username;
    }
  },

  mounted() {
    if (this.chooseServiceType) {
      this.request_quotation.service_type = this.chooseServiceType;
    }
    this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
      document.getElementsByClassName("modal-content").forEach(function (v) {
        v.removeAttribute("tabindex");
      });
    });
    if (
      (this.view_RequestQuotation != null && this.readonly) ||
      (this.view_RequestQuotation != null &&( this.step == "edit_quotation" ||( this.step == 'booking' && this.isCopy == true)))
    ) {

      this.request_quotation = this.view_RequestQuotation;
      this.request_quotation.bookingID = this.view_RequestQuotation.id;
      this.request_quotation.sale_name = this.view_RequestQuotation.sale_name;
      this.request_quotation.customer_name =
        this.view_RequestQuotation.customer_name;

      this.request_quotation.company_id =
        this.view_RequestQuotation.company_id;
      this.request_quotation.customer_id =
        this.view_RequestQuotation.customer_id;
      this.request_quotation.customer_phone =
        this.view_RequestQuotation.customer_phone;
      this.request_quotation.customer_email =
        this.view_RequestQuotation.customer_email;
      this.request_quotation.customer_company_name =
        this.view_RequestQuotation.customer_company_name;
      this.view_RequestQuotation.customer_company_name;

      this.isHideShow =
        this.view_RequestQuotation.other_pickup_location != null ? true : false;

      this.isHideShowPk =
        this.view_RequestQuotation.other_delivery_location != null
          ? true
          : false;

      this.isHideShow =
        this.view_RequestQuotation.other_pickup_region != null ? true : false;

      this.isHideShowPk =
        this.view_RequestQuotation.other_delivery_region != null ? true : false;
      !this.request_quotation.size_
        ? (this.request_quotation = {
            ...this.request_quotation,
            size_: {
              length_: null,
              width_: null,
              height_: null,
            },
          })
        : "";
       
    }
    if (this.booking) {
      this.costs = this.booking.costs;
    }
    if (this.createdRequestQuotation) {
      this.request_quotation = this.createdRequestQuotation;
    }
  },
  methods: {
    onSelectSchedule(e) {
      // console.log(e)

      this.request_quotation.vessel_name = e.load_vessel;
      this.request_quotation.shipping_line = e.carrier_id;
      this.request_quotation.place_of_stuffing = e.stuffing_place_id;
      this.request_quotation.eta = e.eta;
      this.request_quotation.etd = e.etd;
      this.request_quotation.contact = e.contact;
      this.request_quotation.closing_time = e.cargo_cut_off;
      this.request_quotation.cut_si_vgm = e.doc_cut_off;
      this.request_quotation.pod_port = e.pod_code;
      this.request_quotation.pol_port = e.pol_code;
      this.request_quotation.pol_name = e.pol;
      this.request_quotation.pod_name = e.pod;

      this.modalSchedule = false;
    },
    onSelectService(e) {
      this.$emit("onServiceType", this.request_quotation);
    },

    async getDataPolPod() {
      try {
        const data = await this.$store.dispatch("masterData/fetchPortsType");
        if (data && data.result == 1) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("Successfully synchronized to FAST"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("quotationSaveError"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.message,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      setTimeout(() => {
        this.buttonKey++;
      }, 5000);
    },
    getTotal(currency) {
      if (this.costs != null) {
        var t = 0;
        this.costs.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == currency) {
              if (currency == "USD") {
                t += i.qty * (i.unit_price + "").replace(/,/g, "");
              } else {
                t +=
                  i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "");
              }
            }
          });
        });

        return t;
      }
    },
    getTotalAll() {
      if (this.costs != null) {
        var t = 0;
        this.costs.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.currency == "USD") {
              t += i.qty * (i.unit_price + "").replace(/,/g, "");
            } else {
              t +=
                i.qty *
                (i.unit_price + "").replace(/\./g, "").replace(/,/g, "");
            }
          });
        });

        return t;
      }
    },
    getTotalGrandTotal(currency) {
      var t = 0;
      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == currency) {
            if (currency == "USD") {
              t +=
                i.qty * (i.unit_price + "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "");
            } else {
              t +=
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "");
            }
          }
        });
      });
      return t;
    },
    disabledRangeDelivery: function (date) {
      if (this.request_quotation.pick_up_date) {
        var mydate = moment(this.request_quotation.pick_up_date, "DD/MM/YYYY");

        //format that date into a different format
        var now = moment(mydate).format("MM/DD/YYYY");

        return date < new Date(now);
      }
    },

    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    hideShowsi: function () {
      this.isHideShow = !this.isHideShow;
      if (this.isHideShow == true) {
        this.request_quotation.pickup_location = null;
      }
    },
    hideShowsPk: function () {
      this.isHideShowPk = !this.isHideShowPk;
      if (this.isHideShowPk == true) {
        this.request_quotation.delivery_location = null;
      }
    },
    formatOption(arr) {
      const mapData = arr.map((obj) => {
        obj.text = obj.text || obj.name;
        obj.id = obj.code;
        return obj;
      });
      return mapData;
    },
    async sendRequestQuotation() {

      // khách hàng tạo quotation
      let route = this.$router;
      this.request_quotation.files = [];
      for (
        var i = 0;
        i < this.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles().length;
        i++
      ) {
        var file = JSON.parse(
          this.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()[i].xhr
            .response
        ).result;
        file.size =
          this.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()[i].size;
        file.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
        file.uuid =
          this.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()[
            i
          ].upload.uuid;
        file.username = this.userData.username;
        file.fullName = this.userData.fullName;
        this.request_quotation.files.push(file);
      }
      var validate = await this.$refs.requestQuotationRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      if (this.request_quotation.service_type.toString() == "3") {
        const checkPort = this.checkPort(
          this.request_quotation.pol_port,
          this.request_quotation.pod_port,
          this.ports
        );
        if (checkPort != "1") {
          this.activeTab = 0;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: checkPort,
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
      }

      let service =
        this.step == "created-quotation" ||
        this.step == null ||
        this.step == "edit_quotation"
          ? "RequestQuotation"
          : "RequestBooking";
      //if (this.step=='booking' && !this.isCustomer) service='RequestWr1Booking';
      this.$loading.show();
      if (this.view_RequestQuotation != null && !this.readonlyService) {
        useJwt
          .put("wr1?objectType=" + service, this.request_quotation)
          .then((response) => {


            if (this.step == null || this.step == "created-quotation") {
              this.$emit("sendRequestQuotationEvent");
              // route.push({ name: "user-my-quotation" });
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("quotationUpdateSuccess"),
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            } else {
              this.$emit("sendRequestBookingEvent");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("quotationSuccess"),
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("notifyRequestingUpdateQuoteError"),
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => this.$loading.hide());
      } else {
        useJwt
          .post("wr1?objectType=" + service, this.request_quotation)
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("quotationSuccess"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            if (this.step == null || this.step == "created-quotation") {
              this.$emit("sendRequestQuotationEvent");
            } else {
              this.$emit("sendRequestBookingEvent");
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lỗi gửi yêu cầu báo giá, vui lòng thử lại!",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => this.$loading.hide());
      }
    },

    removeFile(file, error, xhr) {
      if (file && file.xhr !== undefined) {
        const xhrJson = JSON.parse(file.xhr.response);
        const path = xhrJson.result.path;
        const bookingId = "-1";
        this.$store.dispatch("attachFile/deleteFile", {
          bookingId,
          path,
        });
      }
    },
    vdropzoneError(file, errorMessage) {
      this.$refs.attachFile.$refs.myVueDropzone.removeFile(file);
      if (errorMessage.includes("Max filesize: 10MiB")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadSizeErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      if (errorMessage.includes("You can not upload any more files.")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadLimitErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
  },
};
</script>
